(function(){
  /* ---------------- i18n ----------------
     The KEY is the English string exactly as it is written here and in the markup, so
     nothing had to be renamed and a missing translation simply leaves the English in
     place. i18n.json holds the table; build-theme-files.py inlines the ONE locale
     Shopify is serving into the snippet as window.LORETANA_ENGRAVING_I18N.

     Named lorT, not t: `t` is already a local inside iconLabel() and capText(), and
     `var` hoisting would make a global t() undefined in exactly those two functions.

     Three rules the translations depend on:
       - lorTf() substitutes {placeholders}. A translation MAY leave one out when its
         own sentence does not need it - lt, lv and et all inflect, so "the {other}"
         becomes "the other side" rather than a noun in the wrong case. It may never
         invent one.
       - capText() keeps returning its ENGLISH sentinels ('Blank', 'nothing yet')
         because switchSide compares against them; capShow() is what reaches the eye.
       - translateDom() replaces a node only when its WHOLE trimmed text is a key, and
         only inside the editor's own root, so it cannot reach the rest of the store. */
  var I18N = (typeof window !== 'undefined' && window.LORETANA_ENGRAVING_I18N) || null;
  function lorT(en){
    if(!I18N || en == null) return en;
    var v = I18N[String(en)];
    return (typeof v === 'string' && v) ? v : en;
  }
  function lorTf(en, vars){
    var out = String(lorT(en));
    for(var k in vars){
      if(Object.prototype.hasOwnProperty.call(vars, k)){
        out = out.split('{' + k + '}').join(vars[k]);
      }
    }
    return out;
  }
  /* Static markup carries no keys of its own - the English IS the key. The attribute
     list is explicit rather than swept, so a data- or class value can never be hit. */
  var I18N_ATTRS = ['aria-label', 'placeholder', 'alt', 'title'];
  function translateDom(root){
    if(!I18N || !root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n;
    var jobs = [];
    while((n = w.nextNode())){
      var raw = n.nodeValue;
      if(!raw) continue;
      var key = raw.replace(/\s+/g, ' ').trim();
      if(!key || !I18N[key]) continue;
      jobs.push([n, raw.replace(key, I18N[key])]);   /* keeps the original padding */
    }
    jobs.forEach(function(j){ j[0].nodeValue = j[1]; });
    var all = root.querySelectorAll('*');
    for(var i = 0; i < all.length; i++){
      for(var a = 0; a < I18N_ATTRS.length; a++){
        var at = I18N_ATTRS[a];
        if(!all[i].hasAttribute(at)) continue;
        var v = all[i].getAttribute(at).replace(/\s+/g, ' ').trim();
        if(v && I18N[v]) { all[i].setAttribute(at, I18N[v]); continue; }
        /* "<product title> — engraving preview, front": the title is already the
           translated one, only the fixed tail after the last dash is a key */
        var cut = v ? v.lastIndexOf(' — ') : -1;
        if(cut > 0 && I18N[v.slice(cut + 3)]) all[i].setAttribute(at, v.slice(0, cut + 3) + I18N[v.slice(cut + 3)]);
      }
    }
  }

  var stage = document.getElementById('stage'), sctx = stage.getContext('2d');
  var stageBack = document.getElementById('stageBack');
  var sctxBack = stageBack ? stageBack.getContext('2d') : null;
  var edC   = document.getElementById('edCanvas'), ectx = edC.getContext('2d');
  var edCB  = document.getElementById('edCanvasBack');
  var ectxB = edCB ? edCB.getContext('2d') : null;
  var ghost = document.getElementById('ghost');
  var ed    = document.getElementById('ed');
  var PLATE = { x:150, y:300, s:140, r:14 };

  /* ---------------- the REAL product photo ----------------
     The customer must see her own piece, not a drawing of one.
     Each entry is the product's own Shopify image plus ONE calibration:
     where the engravable face sits inside that image, as fractions of its width/height.
     Measured from the pixels of the image itself, not estimated.
     A shape with no entry — or a photo that fails to load — falls back to the
     drawn plate below, so the page still works offline.                            */
  /* ---------------- which piece is this page selling? ----------------
     Read from data-product-handle on the wrapper. Without this every engravable
     product showed the COIN, because `shape` kept its default -- a customer on a
     ring page would have been shown a necklace.
     A `photo` entry is only present where the product's own picture can actually
     carry the engraving: flat, facing the camera, and BLANK. Audited 2026-09-18 --
     most cannot: the rings are shot at three-quarters so a flat overlay would lie
     about the piece, and the heart necklace and bar bracelet photos already carry
     an engraving (`As myliu mama`, `LORETANA`). Those fall back to the drawn shape,
     which is honest: a clean diagram of the right product, not a picture of a
     different one. */
  var PRODUCTS = {
    /* Renamed on the live store 2026-09-21 (301s in place). The OLD handles were
       '…-square-pendant-necklace' for the disc and '…-round-coin-necklace' for the
       heart - which is the swap that made the two products point at each other. */
    '925-silver-engraved-coin-necklace':           { shape:'coin',   photo:'coin' },
    '14k-gold-engraved-coin-necklace':             { shape:'coin'   },
    /* this map carries the SHAPE only; its face rectangle is in FACE_BY_HANDLE below */
    '925-silver-engraved-square-necklace':         { shape:'square' },
    '14k-gold-engraved-square-pendant-necklace':   { shape:'square' },
    '925-silver-photo-engraved-heart-necklace':    { shape:'heart'  },
    '14k-gold-photo-engraved-heart-necklace':      { shape:'heart'  },
    '3mm-engravable-silver-stacking-ring':         { shape:'rect'   },
    '3mm-engravable-gold-stacking-ring':           { shape:'rect'   },
    '925-silver-adjustable-engravable-rectangle-ring': { shape:'rect' },
    '14k-gold-adjustable-engravable-rectangle-ring':   { shape:'rect' },
    '925-silver-adjustable-engravable-heart-ring': { shape:'heart'  },
    '14k-gold-adjustable-engravable-heart-ring':   { shape:'heart'  },
    '925-silver-engraved-curved-bar-bracelet':     { shape:'bar'    },
    '14k-gold-engraved-curved-bar-bracelet':       { shape:'bar'    },
    '925-silver-personalized-letter-bangle':       { shape:'bar'    },
    '18k-gold-personalized-letter-bangle':         { shape:'bar'    }
  };

  var PRODUCT_PHOTO = {
    coin: { src:'https://cdn.shopify.com/s/files/1/0958/3971/5663/files/925-silver-engraved-coin-necklace-rhodium.webp?v=1789939214',
            /* the shot is 1000x1000 but the necklace only occupies x 216..777 — the rest is
               empty white that would shrink the piece and make her engraving unreadable.
               crop + face are fractions of the SOURCE image and of the CROP respectively. */
            crop:{ sx:0.340, sy:0.560, sw:0.336, sh:0.370 },
            cx:0.500, cy:0.665, r:0.277,
            title:'925 Silver Engraved Coin Necklace' }
  };
  var shape = 'coin', border = 'gold';
  /* Set by drawTextIcon on the LIVE canvas only: what the size slider asked for versus
     what actually fitted. sync() reads it to tell her when the slider has stopped having
     any effect, instead of leaving her to drag on into a sliced letter. */
  var LOR_FIT = null;
  (function(){
    var host = document.querySelector('.lor-eng');
    var handle = host && host.getAttribute('data-product-handle');
    var cfg = handle && PRODUCTS[handle];
    /* The shop's own answer wins. It is set per product in Shopify admin, so a new
       engravable product needs no code here - which was the whole point. A typo in
       the admin falls through to the table below instead of breaking the editor.
       The five names are written out because SHAPES is declared further down this
       file and is still undefined at this point. */
    var fromShop = host && host.getAttribute('data-engraving-shape');
    if(fromShop && ['coin','square','heart','rect','bar'].indexOf(fromShop) > -1){ shape = fromShop; }
    else if(cfg && cfg.shape){ shape = cfg.shape; }
    /* A product keeps its DRAWN shape unless it is known to have a photo of its own.
       PRODUCT_PHOTO holds one stock picture per shape, and a product configured only
       by metafield has no entry here - so without this it would borrow some other
       product's photograph. Guarded on `host` so the standalone prototype, which has
       no .lor-eng and no handle, keeps its demo pictures. */
    if(host && (!cfg || !cfg.photo)){ PRODUCT_PHOTO = {}; }
  })();
  /* ---------------- does this font actually have this character? ----------------
     FONT_GAPS is a written list, so it only knows what someone wrote down. This asks
     the font instead: the character is drawn once in the chosen face and once in a
     fallback chosen to look nothing like it, and the two bitmaps are compared. If they
     match, the chosen font supplied no glyph and the browser quietly fell through -
     which is how order #1030 reached the workshop with a heart no font could cut.
     Cached per font+character: this runs on every keystroke. */
  var GLYPH_CACHE = {};
  function fontHasGlyph(family, ch){
    var key = family + '\u0000' + ch;
    if(key in GLYPH_CACHE) return GLYPH_CACHE[key];
    var ok = true;
    try {
      var c = document.createElement('canvas');
      c.width = 48; c.height = 48;
      var g = c.getContext('2d', { willReadFrequently:true });
      function bitmap(font){
        g.clearRect(0,0,48,48);
        g.font = '32px ' + font;
        g.textBaseline = 'middle'; g.textAlign = 'center';
        g.fillStyle = '#000';
        g.fillText(ch, 24, 24);
        return g.getImageData(0,0,48,48).data.join(',');
      }
      /* two fallbacks with different shapes: if BOTH match the target, the target drew
         the fallback, not its own glyph. Using one alone would misfire whenever the
         font genuinely resembles it. */
      var target = bitmap('"' + family + '", monospace');
      ok = !(target === bitmap('monospace') && target === bitmap('serif'));
    } catch(e){ ok = true; }   /* never block the customer because the probe failed */
    GLYPH_CACHE[key] = ok;
    return ok;
  }

  /* ---------------- finding the engravable face automatically ----------------
     The shop marks the blank, face-on photo by starting its Alt text with PREVIEW,
     and the snippet passes that image's URL through data-preview-image. Rather than
     hand-calibrating every product, the face is measured FROM THE PICTURE:
       1. everything that is not white is the piece;
       2. the largest connected blob is the pendant / plate / bar, not the chain;
       3. the engraving sits centred on that blob, inset to 0.35 of its shorter side,
          which is the same proportion the hand-measured coin came out at.
     Verified against the coin, whose true face was measured by hand beforehand:
     centre (508,806) radius 93 in a 1000px image. */
  function detectFace(img){
    var N = 260;
    var c = document.createElement('canvas'); c.width = N; c.height = N;
    var g = c.getContext('2d', { willReadFrequently:true });
    g.drawImage(img, 0, 0, N, N);
    var d;
    try { d = g.getImageData(0,0,N,N).data; } catch(e){ return null; }

    /* The chain touches the plate, so a connected blob would swallow it and pull the
       centre upwards. Measuring the WIDEST CONTINUOUS ROW instead gives the plate's
       own width - the same way the first coin was measured by hand - and walking out
       from that row while it stays at least a quarter as wide bounds the plate body
       without ever climbing into the chain. */
    var rows = new Array(N), y, x, i, run, s0, wmax = 0, ymid = 0;
    for(y=0; y<N; y++){
      var best = 0, bs = 0, be = 0; s0 = -1;
      for(x=0; x<=N; x++){
        var on = false;
        if(x<N){ i=(y*N+x)*4; on = (d[i]<243 || d[i+1]<243 || d[i+2]<243); }
        if(on && s0<0) s0 = x;
        else if(!on && s0>=0){ run = x-s0; if(run>best){ best=run; bs=s0; be=x-1; } s0=-1; }
      }
      rows[y] = [best, bs, be];
      if(best > wmax){ wmax = best; ymid = y; }
    }
    if(wmax < N*0.08) return null;

    var top = ymid, bot = ymid, lim = wmax*0.25;
    while(top > 0   && rows[top-1][0] >= lim) top--;
    while(bot < N-1 && rows[bot+1][0] >= lim) bot++;

    var fw = wmax, fh = bot-top+1;
    var cx = (rows[ymid][1] + rows[ymid][2]) / 2, cy = (top+bot) / 2;

    /* BAR ONLY. On a bracelet photographed as a loop the chain lies in the SAME rows as
       the plate, so the longest-run scan above returns bar + stone + chain as one face:
       measured 0.591 of the image on the gold curved bar, where the flat plate is 0.377.
       The engraving is clipped to that face, so it was painted over the chain and the
       stone. The mark never crossed its boundary -- the boundary was wrong. Owner
       reported it twice on 2026-09-21, the second time with fifteen characters running
       off both ends of the plate.

       The plate is thick and the chain beside it is thin, so inside the face's own row
       band keep only the central block of columns that fill at least 75% of it. 0.75 was
       not picked by feel: 0.55, 0.75 and 0.88 were each drawn over the real photos. 0.55
       still swallowed the stone, 0.88 cut inside the plate, 0.75 lands on the flat
       surface and stops at the stone's bezel -- on both bracelets and both bangles.

       Gated to 'bar' deliberately. Run against all sixteen products this test narrowed
       EIGHT that were already correct: a coin is round, so its edge columns are honestly
       thin and it loses 12-21% of a good face. Compact shapes have no chain lying in
       their own rows, so they have nothing here to fix. */
    if(shape === 'bar'){
      var bs0 = rows[ymid][1], be0 = rows[ymid][2];
      var need = Math.max(1, Math.floor(fh * 0.75));
      var fill = {}, xx, yy, n;
      for(xx = bs0; xx <= be0; xx++){
        n = 0;
        for(yy = top; yy <= bot; yy++){
          i = (yy*N + xx)*4;
          if(d[i] < 243 || d[i+1] < 243 || d[i+2] < 243) n++;
        }
        fill[xx] = n;
      }
      var blocks = [], st = -1, ok, k;
      for(xx = bs0; xx <= be0 + 1; xx++){
        ok = (xx <= be0) && (fill[xx] >= need);
        if(ok && st < 0) st = xx;
        else if(!ok && st >= 0){ blocks.push([st, xx-1]); st = -1; }
      }
      if(blocks.length){
        var pick = null;
        for(k = 0; k < blocks.length; k++){
          if(blocks[k][0] <= cx && cx <= blocks[k][1]){ pick = blocks[k]; break; }
        }
        if(!pick){
          pick = blocks[0];
          for(k = 1; k < blocks.length; k++){
            if(blocks[k][1]-blocks[k][0] > pick[1]-pick[0]) pick = blocks[k];
          }
        }
        /* a speck is not a plate; leave the untrimmed face rather than invent one */
        if(pick[1]-pick[0]+1 >= 6){ fw = pick[1]-pick[0]+1; cx = (pick[0]+pick[1])/2; }
      }
    }

    /* A plate is never much taller than it is wide. A ring photographed at an angle
       measures 408 x 892 here: that is the whole ring, not a face, and drawing flat
       text on it would misrepresent the piece. Refuse, and let the drawn shape show. */
    if(fh / fw > 1.6) return null;

    var pad = Math.max(fw, fh) * 0.12;
    var sx0 = Math.max(0, cx - fw/2 - pad),  sy0 = Math.max(0, cy - fh/2 - pad*1.8);
    var sx1 = Math.min(N, cx + fw/2 + pad),  sy1 = Math.min(N, cy + fh/2 + pad*0.8);
    var sw = sx1-sx0, sh = sy1-sy0;
    return {
      crop:{ sx:sx0/N, sy:sy0/N, sw:sw/N, sh:sh/N },
      cx:(cx-sx0)/sw, cy:(cy-sy0)/sh,
      fw:fw/sw, fh:fh/sh,
      measured:{ wPx:fw, hPx:fh, ratio:+(fh/fw).toFixed(2) }
    };
  }

  /* ---------------- faces the row scan cannot find ----------------
     detectFace looks for the WIDEST CONTINUOUS ROW of the piece. On a pendant that
     row is the disc, which is why the coins, hearts, bars and bangles all land right.
     On a ring it is the shank and shoulders - never the plate - so the engraving was
     being drawn on the shadow under the ring (seen on the test theme 2026-09-18).

     No brightness threshold fixes this. Lowering it from 243 was tried at 225 and 205:
     the rings improve and the SILVER pieces disappear, because polished rhodium on
     white and a soft drop shadow are the same pale grey. The problem is not which
     pixels are the piece, it is which part of the piece is the face.

     So these four faces are measured off the photographs once, as fractions of the
     image. Everything else still auto-detects, and a new product with a blank photo
     needs no entry here unless it is a ring. */
  var FACE_BY_HANDLE = {
    /* Calibrated because detectFace() REFUSES this one. It rejects any face taller than
       1.6x its width, since a ring photographed at an angle measures 408x892 there and
       flat text on that would misrepresent the piece. This pendant is honestly
       rectangular and its photo measures 32x53 = 1.66 -- just over the line -- so the
       editor fell back to a DRAWN square on a panel captioned "YOUR ACTUAL PIECE".
       Its 14K twin is shot slightly wider (37x54 = 1.46) and passes, which is why only
       one of the pair was wrong and why it went unnoticed. Raising the threshold would
       let genuinely bad detections through, so one rectangle is the safer fix.
       Read off the photo and checked against it by eye, 2026-09-21. */
    '925-silver-engraved-square-necklace':             { cx:0.507, cy:0.764, fw:0.145, fh:0.241 },
    /* The four bars are declared rather than detected. detectFace() was trimmed sideways
       so the chain and the stone stopped being counted as face, but its row band is still
       grown while a row is >=25% of the widest -- which on a bracelet lying as a loop
       climbs into the curve above and below the plate. Owner, 2026-09-21, with the guide
       drawn over his own bracelet: "the canvas very big then the item".
       Measured on the live dialog canvas: the guide came out 568 x 127 px, 23% of the
       canvas height, while the plate is about 12% of the photo -- roughly twice as tall.
       Both rectangles below were read off the preview photos (plate columns, then the
       rows where >=80% of those columns are metal) and checked against the photographs
       by eye before being written here. */
    '14k-gold-engraved-curved-bar-bracelet':           { cx:0.495, cy:0.898, fw:0.377, fh:0.118 },
    '925-silver-engraved-curved-bar-bracelet':         { cx:0.482, cy:0.902, fw:0.350, fh:0.100 },
    '18k-gold-personalized-letter-bangle':             { cx:0.498, cy:0.559, fw:0.591, fh:0.068 },
    '925-silver-personalized-letter-bangle':           { cx:0.516, cy:0.566, fw:0.418, fh:0.064 },
    '925-silver-adjustable-engravable-rectangle-ring': { cx:0.500, cy:0.375, fw:0.46, fh:0.145 },
    '14k-gold-adjustable-engravable-rectangle-ring':   { cx:0.505, cy:0.375, fw:0.47, fh:0.150 },
    /* A band ring has no plate: the engraving goes on the outer surface, which in these
       photographs is the strip across the BOTTOM of the ellipse - the part facing the
       lens. 0.635 was read off a grid by eye and landed on that strip's top EDGE, so the
       text sat on the rim rather than on the metal (owner, 2026-09-19).
       Re-measured down the centre column instead: the column reads metal / hole / metal,
       and the near strip runs 0.634 to 0.742 on both rings. A threshold of 200 luminance
       is what separates it from the pale reflection beneath, which is why the first
       automatic attempt swallowed the shadow and put the box lower still. */
    '3mm-engravable-silver-stacking-ring':             { cx:0.500, cy:0.688, fw:0.50, fh:0.086 },
    '3mm-engravable-gold-stacking-ring':               { cx:0.500, cy:0.688, fw:0.50, fh:0.086 },
    /* The heart NECKLACES. detectFace() found a box 9% short of the pendant and 16 canvas
       px too high: 6 px of metal above the engraving, 38 below. These are the pendant
       itself, with NO inset - owner, 2026-09-21: "for the images it takes all the heart or
       circle, no border, the border in the text". Read off each preview at 700x700 and
       checked against the drawn box, because the automatic reader kept failing on these
       two: the polished silver carries near-white highlights, so a background threshold
       tight enough to keep the chain out also eats the pendant's own edge. */
    /* The COIN necklaces. detectFace() came up 12% short in height, so once the photo
       was clipped to face-rect AND silhouette a rim of bare silver showed round it -
       owner, 2026-09-22: "isue with circle, there is a border for the image doesnt fill
       all the circle", with a render of the disc filled edge to edge: "its should be
       like this". These are the disc itself, found by flooding the white background in
       from the border - the two boxes came out 1.03 wide to tall, which is the check
       that a disc was measured and not a highlight. */
    '925-silver-engraved-coin-necklace':        { cx:0.501, cy:0.665, fw:0.510, fh:0.496 },
    '14k-gold-engraved-coin-necklace':          { cx:0.501, cy:0.665, fw:0.510, fh:0.495 },
    '925-silver-photo-engraved-heart-necklace': { cx:0.500, cy:0.817, fw:0.273, fh:0.244 },
    '14k-gold-photo-engraved-heart-necklace':   { cx:0.500, cy:0.817, fw:0.273, fh:0.244 },
    /* Xinyun, 03/11 - owner: "i want to see real item" instead of the drawn plate. Each
       product's first photo now carries the PREVIEW alt; read off it on a 2.5% grid and
       drawn back over the photo. Disc bracelets: the whole disc. Bar sliders: the top face
       BETWEEN the two jump-ring holes, so a name never runs into a hole. Halo discs: the
       polished disc inside the stones (0.70 of the halo), which is all the laser may touch. */
    '18k-gold-engravable-disc-bracelet':           { cx:0.480, cy:0.835, fw:0.145, fh:0.147 },
    '925-silver-engravable-disc-bracelet':         { cx:0.480, cy:0.839, fw:0.143, fh:0.143 },
    '18k-gold-engravable-bar-slider-bracelet':     { cx:0.510, cy:0.741, fw:0.297, fh:0.042 },
    '925-silver-engravable-bar-slider-bracelet':   { cx:0.510, cy:0.741, fw:0.297, fh:0.042 },
    '18k-gold-engravable-halo-disc-necklace':      { cx:0.502, cy:0.756, fw:0.277, fh:0.277 },
    '925-silver-engravable-halo-disc-necklace':    { cx:0.502, cy:0.768, fw:0.275, fh:0.275 },
  };

  /* Finding the whole piece is easy - it is only the face that defeats the scan - so
     the crop is still measured from the picture and only the face comes from above. */
  function faceFromRect(img, o, focus){
    var N = 220;
    var c = document.createElement('canvas'); c.width = N; c.height = N;
    var g = c.getContext('2d', { willReadFrequently:true });
    g.drawImage(img, 0, 0, N, N);
    var d;
    try { d = g.getImageData(0,0,N,N).data; } catch(e){ return null; }
    var x0=N, y0=N, x1=-1, y1=-1;
    for(var y=0; y<N; y++) for(var x=0; x<N; x++){
      var i=(y*N+x)*4;
      if(d[i]<243 || d[i+1]<243 || d[i+2]<243){
        if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y;
      }
    }
    if(x1 < 0) return null;
    var pad = Math.max(x1-x0, y1-y0) * 0.06;
    var sx = Math.max(0, (x0-pad)/N), sy = Math.max(0, (y0-pad)/N);
    var sw = Math.min(1, (x1+pad)/N) - sx, sh = Math.min(1, (y1+pad)/N) - sy;
    /* NECKLACES frame the pendant, not the whole necklace. The crop above is the whole
       piece, chain included, so the plate she engraves came out a small tile at the foot
       of a tall picture - owner, 2026-09-24: "we need to focus on the pendant not the
       necklace all". The rectangle above IS the pendant (the coins and hearts are the
       disc itself, the square is its plate), so the frame is that rectangle plus a margin
       - more above, to keep the bail and a little chain so it still reads as a necklace.
       Rings and bars keep the whole piece: their face is a strip across it. */
    if(focus){
      var m = Math.max(o.fw, o.fh) * 0.22;
      sx = Math.max(0, o.cx - o.fw/2 - m);  sy = Math.max(0, o.cy - o.fh/2 - m*1.6);
      sw = Math.min(1, o.cx + o.fw/2 + m) - sx;  sh = Math.min(1, o.cy + o.fh/2 + m*0.9) - sy;
    }
    if(sw <= 0 || sh <= 0) return null;
    return {
      crop:{ sx:sx, sy:sy, sw:sw, sh:sh },
      cx:(o.cx-sx)/sw, cy:(o.cy-sy)/sh,
      fw:o.fw/sw, fh:o.fh/sh,
      measured:{ source:'per-product rectangle' }
    };
  }

  var photoCache = {};
  function productPhoto(){
    var host = document.querySelector('.lor-eng');
    var handle = host && host.getAttribute('data-product-handle');
    var marked = host && host.getAttribute('data-preview-image');
    var cfg = marked ? { src: marked, auto:true } : PRODUCT_PHOTO[shape];
    if(!cfg) return null;
    var key = cfg.src; var slot = photoCache[key];
    if(!slot){
      slot = photoCache[key] = { cfg:cfg, img:new Image(), ready:false, failed:false };
      slot.img.crossOrigin = 'anonymous';
      slot.img.onload  = function(){
        if(slot.cfg.auto){
          var ovr = handle && FACE_BY_HANDLE[handle];
          /* 03/11 owner: the disc bracelets framed like the Coin - the 12 mm disc is 15% of a
             whole-bracelet photo, so the name was too small to read. Bars keep the whole piece. */
          var f = ovr ? faceFromRect(slot.img, ovr, /necklace|disc-bracelet/.test(handle || '')) : detectFace(slot.img);
          if(f){ slot.cfg.crop = f.crop; slot.cfg.cx = f.cx; slot.cfg.cy = f.cy; slot.cfg.fw = f.fw; slot.cfg.fh = f.fh; slot.cfg.detected = f.measured; }
          else { slot.failed = true; sync(); return; }   /* no face found: draw the shape instead */
        }
        /* B.10 - this is the moment the drawn plate becomes a photograph AND the moment
           the canvas changes shape. Both happen behind the fade. */
        slot.ready = true;  swapFaces(sync);
      };
      slot.img.onerror = function(){ slot.failed = true; sync(); };
      slot.img.src = cfg.src;
    }
    return slot.ready ? slot : null;
  }
  /* The piece's own outline, flooded out of its photograph. Idealised paths cannot
     follow a real pendant: fitting the heart's Beziers to this one still left 13% of the
     metal bare - the slivers at both lobes and the tip the owner circled on 2026-09-21,
     "user shouldnt see that marked with red" / "the image should fit the item".

     Flood the near-white inwards from the border rather than thresholding: polished
     silver carries specular highlights as bright as the background, and a plain
     threshold punches holes straight through the middle of the piece.

     Built once per product and cached on the slot; a tainted canvas returns null and
     every caller falls back to pathIn(). */
  function silhouette(slot){
    if(slot.mask !== undefined) return slot.mask;
    var im = slot.img, W = im.width, H = im.height;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var g = c.getContext('2d', { willReadFrequently:true });
    g.drawImage(im, 0, 0);
    var d;
    try { d = g.getImageData(0, 0, W, H); } catch(e){ return (slot.mask = null); }
    var px = d.data, n = W*H, bg = new Uint8Array(n), stack = new Int32Array(n), sp = 0;
    function white(i){ var j = i*4; return px[j] >= 246 && px[j+1] >= 246 && px[j+2] >= 246; }
    function seed(i){ if(!bg[i] && white(i)){ bg[i] = 1; stack[sp++] = i; } }
    for(var x = 0; x < W; x++){ seed(x); seed((H-1)*W + x); }
    for(var y = 0; y < H; y++){ seed(y*W); seed(y*W + W - 1); }
    while(sp){
      var i = stack[--sp], ix = i % W, iy = (i / W) | 0;
      if(ix > 0)   seed(i-1);
      if(ix < W-1) seed(i+1);
      if(iy > 0)   seed(i-W);
      if(iy < H-1) seed(i+W);
    }
    for(var k = 0; k < n; k++){
      var j = k*4;
      px[j] = px[j+1] = px[j+2] = 255;
      px[j+3] = bg[k] ? 0 : 255;
    }
    g.putImageData(d, 0, 0);
    return (slot.mask = c);
  }

  /* the engravable face as a rectangle in the SOURCE image, so the mask can be sampled
     with the same geometry from the render, which has no crop of its own */
  function faceSrc(slot){
    var im = slot.img, c = slot.cfg, cr = c.crop || {sx:0, sy:0, sw:1, sh:1};
    var fw = c.fw * cr.sw * im.width, fh = c.fh * cr.sh * im.height;
    return { sx: (cr.sx + c.cx*cr.sw)*im.width  - fw/2,
             sy: (cr.sy + c.cy*cr.sh)*im.height - fh/2, sw: fw, sh: fh };
  }

  /* where the engraving lands on that photo, in canvas pixels */
  function photoFace(slot, W, H){
    var im = slot.img, c = slot.cfg;
    var cr = c.crop || {sx:0,sy:0,sw:1,sh:1};
    var sx = cr.sx*im.width, sy = cr.sy*im.height,
        sw = cr.sw*im.width, sh = cr.sh*im.height;
    var k  = Math.min(W/sw, H/sh);
    var dw = sw*k, dh = sh*k;
    var dx = (W-dw)/2, dy = (H-dh)/2;
    var X  = dx + c.cx*dw, Y = dy + c.cy*dh;
    /* fw/fh describe the engravable face itself; r survives for hand-calibrated entries */
    var fw = (c.fw != null ? c.fw*dw : c.r*dw*2);
    var fh = (c.fh != null ? c.fh*dh : c.r*dw*2);
    var R  = Math.min(fw, fh)/2;
    /* FACE_USE - how much of the detected face the engraving is previewed on.
       It was 0.72, described as "inset from the rim, as a real engraver would". Measured
       against what the workshop actually receives, that description was wrong and the
       preview under-sold the engraving:

         renderCanvas() - the 900 px file the machine marks from - clips to
           pathIn(shape, bx, by, bw, bh) where bw/bh is the WHOLE tile less a 5% pad,
           and artRect() fits the art to that same box. The engraving fills the face.
         the drawn preview - clips to platePath(g,0), which is box(0), the whole plate.
           Also fills the face, and it is what the owner recognised as correct.
         this path alone clipped to 0.72 of the face - 28% smaller across, about half
           the area - so a photo looked like a sticker in the middle of the disc while
           the machine was going to mark the whole face.

       Owner reported it from the theme editor on 2026-09-21 with both screens side by
       side. One number, named, so it can be dialled if a real test card ever says the
       rim needs clearing - and then it must move in renderCanvas() too, not here alone. */
    var FACE_USE = 1.0;
    var bw2 = fw*FACE_USE, bh2 = fh*FACE_USE;
    return { sx:sx, sy:sy, sw:sw, sh:sh, dx:dx, dy:dy, dw:dw, dh:dh, X:X, Y:Y, R:R,
             fw:fw, fh:fh,
             B:{ x:X-bw2/2, y:Y-bh2/2, w:bw2, h:bh2 } };
  }

  /* the 16 engraving fonts the live theme really offers.
     three carry no latin-ext, so Lithuanian marks do not render. */
  /* 25 faces. The nine added 2026-09-20 were each measured for FULL Baltic coverage
     before being listed - Satisfy, Cookie and Sacramento were rejected on that test
     (30, 30 and 1 missing letters). A face the machine cannot cut must never reach
     this array: every name here has a matching .ttf in 01_PRODUCTS/Engraving-Fonts. */
  var FONTS = ['Alex Brush','Amatic SC','Bebas Neue','Caveat','Cinzel','Cormorant Garamond',
    'Dancing Script','EB Garamond','Fredoka','Great Vibes','Jost','Marcellus','Montserrat',
    'Open Sans','Orbitron','Pacifico','Parisienne','Playfair Display','Poiret One','Prata',
    'Quicksand','Roboto','Source Code Pro','Special Elite','UnifrakturMaguntia'];
  /* Exactly which Baltic letters each font FILE is missing, read from the .ttf
     with fontTools on 2026-09-18 -- not a hand-kept list. A missing glyph is
     silent: the browser substitutes another face in the preview, so only the
     engraved piece would have shown the problem. Rebuild with build_gapmap.py. */
  var FONT_GAPS = {
    'Fredoka': 'ĀāĄąČčĒēĖėĘęĢģĪīĮįĶķĻļŅņŪūŲų',
    'Orbitron': 'ĀāĄąČčĒēĖėĘęĢģĪīĮįĶķĻļŅņŪūŲų',
    'Prata': 'ĀāĄąČčĒēĖėĘęĢģĪīĮįĶķĻļŅņŠšŪūŲųŽž',
    'UnifrakturMaguntia': 'ĀāĄąČčĒēĖėĘęĢģĪīĮįĶķĻļŅņŪūŲų',
  };
  var BALTIC_RE = /[ąčęėįšųūžĄČĘĖĮŠŲŪŽāčēģīķļņšūžĀČĒĢĪĶĻŅŠŪŽäöüõšžÄÖÜÕŠŽ]/;

  /* ---- the font guard ---------------------------------------------------------
     It warned and then let the piece through. She picked Prata, typed Ąžuolas, read
     the amber line, and bought anyway - and the laser cut the two letters the font
     does not carry in whatever the browser substituted. Permanent, on silver.

     Two checks, deliberately not equal in authority:
       FONT_GAPS  - a written table someone verified. This one BLOCKS.
       fontHasGlyph - a canvas probe. It WARNS only, and never blocks: a browser that
                      farbles canvas readback (Brave, Firefox RFP) makes it answer
                      "has glyph" for everything, and a false answer the other way
                      would make a product nobody can buy. */
  function missingIn(st, hardOnly){
    if(!st || st.mode !== 'text') return '';
    var gap = FONT_GAPS[st.font] || '', hit = '';
    for(var i=0;i<st.text.length;i++){
      var ch = st.text.charAt(i);
      if(ch === ' ') continue;
      /* 03/11: an emoji that got past the inputs (a restored draft) blocks - no font cuts it */
      var bad = gap.indexOf(ch) > -1 || /[\uD800-\uDFFF\u2600-\u27BF\u2B00-\u2BFF]/.test(ch)
             || (!hardOnly && !fontHasGlyph(st.font, ch));
      if(bad && hit.indexOf(ch) < 0) hit += ch;
    }
    return hit;
  }
  /* '' when the editor is safe to confirm. */
  function blockedReason(){
    if(missingIn(S.front, true)) return 'front';
    if(SIDES === 2 && missingIn(S.back, true)) return 'back';
    return '';
  }
  /* 15 characters. The owner set 15 on every engravable product's Shopify metafield and
     confirmed it on 2026-09-21 ("its 15 we update this"), so this fallback was raised
     from 12 to match: the two numbers had been disagreeing, and the metafield wins
     anyway (see the read below), so 12 only ever misled whoever read this file.

     Where 12 came from, kept because the measurement is still the reason there is a cap
     at all: the usable width on a 20 mm disc is 15.5 mm, so 12 characters leave the
     letters about 1.8 mm tall, and 15 leave them about 1.44 mm -- both readable on a
     worn pendant. At the old limit of 25 they fell to roughly 0.9 mm: markable by the
     laser, but not readable by the eye. That is the line this cap exists to stay above. */
  /* Fifteen is what a coin, a bar or a signet plate can carry. The adjustable HEART
     rings cannot: their plate is a small heart and only one initial fits, so they are
     capped at one. Keyed by handle, not by shape - the heart NECKLACES are the same
     'heart' shape and keep the full fifteen. Owner's instruction, 2026-09-18.
     CAUTION: the metafield is read BEFORE this table (else-if below), so filling
     engraving_max_chars on a heart RING with anything above 1 silently defeats this cap
     and offers an engraving its plate cannot hold. */
  var MAXLEN_BY_HANDLE = {
    '925-silver-adjustable-engravable-heart-ring': 1,
    '14k-gold-adjustable-engravable-heart-ring':   1
  };
  /* How many faces of this piece can actually be engraved. A ring has ONE - the
     outer band, or the plate - so offering a BACK offers something that cannot be
     made. Owner, 2026-09-18: "for the ring there is only front on the surface, not
     like a pendant front and back". Set per product in Shopify admin. */
  var SIDES = 2;
  (function(){
    var host = document.querySelector('.lor-eng');
    var n = parseInt(host && host.getAttribute('data-engraving-sides'), 10);
    if(n === 1 || n === 2) SIDES = n;
  })();

  /* Photo engraving is not offered on every piece. It needs a face big enough to hold
     a recognisable image, which rules out rings, earrings and bracelets - and will rule
     out the small pendant coming later, even though it IS a pendant. So this is decided
     per product in Shopify admin, never inferred from the shape or the product type.
     Owner, 2026-09-18: "photo available only for pendant necklace ... also i have a
     small pendant in the future only for text, no space for image".

     Default when the field is empty is NO. A new product that nobody has configured
     must not quietly offer an engraving the workshop cannot cut. */
  var PHOTO_OK = false;
  (function(){
    var host = document.querySelector('.lor-eng');
    if(!host){ PHOTO_OK = true; return; }   /* the standalone prototype keeps every mode */
    PHOTO_OK = host.getAttribute('data-engraving-photo') === 'true';
  })();

  var MAXLEN = 15;
  (function(){
    var host = document.querySelector('.lor-eng');
    var h = host && host.getAttribute('data-product-handle');
    /* Set per product in Shopify admin. Range-checked so a stray value in the admin
       cannot hand the laser a 5,000-character name or a zero-length one. */
    var fromShop = parseInt(host && host.getAttribute('data-engraving-maxlen'), 10);
    if(fromShop >= 1 && fromShop <= 30) MAXLEN = fromShop;
    else if(h && MAXLEN_BY_HANDLE[h]) MAXLEN = MAXLEN_BY_HANDLE[h];
  })();

  /* the shape belongs to the PRODUCT, never to the customer */
  var SHAPES = {
    square: { w:1.00, h:1.00, label:lorT('Square plate'),  fit:0.82, product:'Engravable Square Necklace' },
    /* ti 0.88 is not a taste: the calibrated face is 14% taller than the one detectFace
     returned, so without it every name on a coin would jump 14% overnight. 0.88 is
     the reciprocal, measured - the photo gains the whole disc, the type stays exactly
     the size the owner already approved, and it gains the border he asked text to
     keep. */
  coin:   { w:1.00, h:1.00, label:lorT('Round coin'),    fit:0.78, ti:0.88, product:'Engraved Coin Necklace' },
    /* ti - how much of the face the TEXT may use. The photo always uses all of it:
     owner, 2026-09-21, "for the images it takes all the heart or circle, no border,
     the border in the text", with a smaller heart drawn inside the pendant. His
     drawing measures 0.70 across and 0.79 down; 0.78 sits between them. Every other
     shape keeps 1 - their faces are already the engravable plate, not the whole piece,
     so insetting them would shrink type the owner has already approved. */
  heart:  { w:1.06, h:0.98, label:lorT('Heart pendant'), fit:0.62, ti:0.78, product:'Photo Engraved Heart Necklace' },
    rect:   { w:1.24, h:0.74, label:lorT('Rectangle'),     fit:0.80, product:'Engravable Rectangle Ring' },
    bar:    { w:1.70, h:0.40, label:lorT('Curved bar'),    fit:0.86, product:'Engraved Curved Bar Bracelet' }
  };
  /* The names above are the prototype's own stand-ins, one per shape. On a real product
     page the snippet passes the shop's title in data-product-title, and THAT is what the
     customer must see: without this the bangle page read "Engraved Curved Bar Bracelet ·
     925 Silver" - wrong piece and wrong metal, since the suffix was hard-coded too while
     half the catalogue is 14K or 18K gold. Seen on the test theme 2026-09-18. */
  function productName(){
    var host = document.querySelector('.lor-eng');
    var real = host && host.getAttribute('data-product-title');
    if(real) return real;
    return SHAPES[shape].product + ' · 925 Silver';
  }
  /* Both of these belong to the PRODUCT, never to the customer.
     The frame colour follows the piece's own plating and is not a choice on the page. */

  var BORDER = { gold:'#A37E2C', black:'#111111' };

  var S = {
    front:{ mode:'none', art:null, zoom:1, off:{x:0,y:0}, text:'', font:'Playfair Display', icon:null, iconPos:'above', scale:1, name:'', thumb:'', verdict:null },
    back: { mode:'none', art:null, zoom:1, off:{x:0,y:0}, text:'', font:'Playfair Display', icon:null, iconPos:'above', scale:1, name:'', thumb:'', verdict:null }
  };
  var side = 'front', tray = null, typing = false, caretOn = true, snapshot = null;
  function cur(){ return S[side]; }
  function other(){ return side === 'front' ? 'back' : 'front'; }

  /* ---- what each face is carrying, in a few words -----------------------------
     So she can see what is on the face she is NOT looking at without switching to
     find out - which was the only way to know before. */
  /* `name` is the SEARCH string - 'two hearts love couple' - so anything that showed it
     to a customer showed her keywords. `label` is the one human name for the symbol, and
     it is what the side card, the chip, the proof panel and the cart all print. */
  /* Shown text only. The stored values stay 'above|before|after|below' (and legacy
     'beside'), because they travel to the workshop and sit in pieces saved before
     this rename. "Before/After" read as time once translated - Lithuanian would get
     'Prieš/Po', which is when, not where. Left/Right is where. */
  var POS_LABEL = { above:lorT('Above'), below:lorT('Below'), before:lorT('Left'), after:lorT('Right'), beside:lorT('Left') };
  function posLabel(v){ return lorT(POS_LABEL[v] || POS_LABEL.above); }

  function iconLabel(id){
    var ic = iconById(id);
    if (ic && ic.label) return lorT(ic.label);
    var t = String(id || '').replace(/-/g, ' ');
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : '';
  }
  /* capText keeps its ENGLISH sentinels - switchSide compares against them.
     capShow is the translated one, and it is the only one a customer reads. */
  function capShow(k){ return lorT(capText(k)); }
  function capText(k){
    var s = S[k];
    if(s.mode === 'photo') return s.art ? lorT('your photo') : lorT('no photo yet');
    if(s.mode === 'text'){
      var t = clean(s.text);
      if(t) return '“' + (t.length > 9 ? t.slice(0, 8) + '…' : t) + '”';
      if(s.icon) return iconLabel(s.icon);
      return 'nothing yet';
    }
    return 'Blank';
  }

  /* One polite sentence at a time. A screen reader gets the same information the
     caption and the ring give everyone else. */
  /* quiet = still announced to a screen reader, but not painted: the owner removed the
     running commentary from the stage (2026-09-24, "delete not necessary text"). Only a
     message she has to act on - a font that cannot cut her letters - stays on screen. */
  function say(msg, quiet){
    var n = document.getElementById('edSay');
    if(!n) return;
    n.textContent = msg || '';
    n.classList.toggle('quiet', !!quiet);
  }

  /* Switching faces is a change of subject and should feel like one. The field fades
     across its new value instead of blinking out, which is what made the switch read
     as "my words are gone". */
  function switchTo(which, then){
    if(which === side){ if(then) then(); return; }
    var f = document.getElementById('engText');
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function apply(){
      side = which;
      document.querySelectorAll('.tabs button').forEach(function(b){
        b.setAttribute('aria-selected', String(b.dataset.side === side)); });
      sync();
      var o = which === 'front' ? 'back' : 'front', w = capText(o);
      var blankish = (w === 'Blank' || w === 'nothing yet');
        say(blankish
          ? lorTf('Now editing the {side} — the {other} is blank.', { side: lorT(which), other: lorT(o) })
          : lorTf('Now editing the {side} — the {other} says {what}.', { side: lorT(which), other: lorT(o), what: lorT(w) }), true);
      if(then) then();
    }
    if(rm || !f){ apply(); return; }
    f.classList.add('swap');
    setTimeout(function(){ apply(); f.classList.remove('swap'); }, 100);
  }

  var LIB = [
    { cat:lorT('MOST LOVED'), items:[
      { id:'double-heart', label:lorT('Two hearts'), name:'two hearts love couple', d:'M9.6 18.4C5.6 15.5 3 13.2 3 10.5A3.3 3.3 0 0 1 9.6 8.8 3.3 3.3 0 0 1 16.2 10.5c0 2.7-2.6 5-6.6 7.9z M14.6 17.2c3.8-2.8 6.4-5.1 6.4-7.8a3.3 3.3 0 0 0-6.1-1.8' },
      { id:'infinity', label:lorT('Infinity'),     name:'infinity always forever', d:'M7.6 8.8a3.2 3.2 0 1 0 0 6.4c2.2 0 3.2-3.2 4.4-3.2s2.2 3.2 4.4 3.2a3.2 3.2 0 1 0 0-6.4c-2.2 0-3.2 3.2-4.4 3.2S9.8 8.8 7.6 8.8z' },
      { id:'heart-solid', label:lorT('Solid heart'), fill:true, name:'solid heart filled love full',
        d:'M12 20.4C6.6 16.4 3.2 13.3 3.2 9.8A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 8.8 2.2c0 3.5-3.4 6.6-8.8 10.6z' },
      { id:'heartbeat', label:lorT('Heartbeat'), name:'heartbeat pulse ecg heart rate alive life line',
        d:'M2 12.4h4.2l2-4.6 2.8 9.4 2.6-11.2 2.2 6.4h6.2' },
      { id:'gift', label:lorT('Gift'), name:'gift present box ribbon bow birthday surprise',
        d:'M12 10.6 8.8 6.4a2.6 2.6 0 1 1 3.2-1.2 2.6 2.6 0 1 1 3.2 1.2z M4.4 12.6h15.2v7.8H4.4Z M12 10.6v9.8 M4.4 12.6h15.2' },
      { id:'heart', label:lorT('Heart'),        name:'heart love love',             d:'M12 20.4C6.6 16.4 3.2 13.3 3.2 9.8A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 8.8 2.2c0 3.5-3.4 6.6-8.8 10.6z' },
      { id:'baby-feet', label:lorT('Baby feet'),    name:'baby feet newborn child', d:'M8.4 20.6c-1.7 0-2.6-1.1-2.6-2.5 0-1.7 1.1-2.6 1.1-4.2 0-1.7 1-2.9 2.4-2.9 1.5 0 2.4 1.3 2.4 3.1 0 2.7-1.6 6.5-3.3 6.5z M6 8.4a1 1 0 1 0 2 0 1 1 0 1 0-2 0 M8.6 7a1 1 0 1 0 2 0 1 1 0 1 0-2 0 M11.2 6.6a1 1 0 1 0 2 0 1 1 0 1 0-2 0 M16.4 20.6c1.7 0 2.6-1.1 2.6-2.5 0-1.7-1.1-2.6-1.1-4.2 0-1.7-1-2.9-2.4-2.9' },
      { id:'mom', label:lorT('Mom'),          name:'mom mother mum mama',    d:'M4 16v-5c0-1.1.9-2 2-2s2 .9 2 2v5 M8 11c0-1.1.9-2 2-2s2 .9 2 2v5 M14.8 12.6a2.4 2.4 0 0 1 4.6 1.2c0 1.7-2.3 3.4-2.3 3.4s-2.3-1.7-2.3-3.4a2.4 2.4 0 0 1 0-1.2z M20 16v-5c0-1.1-.9-2-2-2' },
      { id:'paw', label:lorT('Paw print'),          name:'paw pet dog cat animal', d:'M7.6 6.2a1.9 2.4 0 1 0 0 4.8 1.9 2.4 0 1 0 0-4.8z M16.4 6.2a1.9 2.4 0 1 0 0 4.8 1.9 2.4 0 1 0 0-4.8z M3.8 11.4a1.7 2.1 0 1 0 0 4.2 1.7 2.1 0 1 0 0-4.2z M20.2 11.4a1.7 2.1 0 1 0 0 4.2 1.7 2.1 0 1 0 0-4.2z M12 12.8c2.9 0 5.2 2.2 5.2 4.3S14.9 21 12 21s-5.2-1.8-5.2-3.9S9.1 12.8 12 12.8z' },
      { id:'rings', label:lorT('Wedding rings'),        name:'rings wedding marriage engagement anniversary bands wedding ring', d:'M9.4 14.6a4.3 4.3 0 1 0 0-8.6 4.3 4.3 0 0 0 0 8.6z M14.6 14.6a4.3 4.3 0 1 0 0-8.6 4.3 4.3 0 0 0 0 8.6z M12 3.4l1.4 1.8h-2.8z' },
      { id:'rose', label:lorT('Rose'),         name:'rose flower bloom flowers floral flower',      d:'M12 10.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2z M9 8c-1.5.6-2.4 2-2.4 3.6 0 2.4 2.4 4 5.4 4s5.4-1.6 5.4-4c0-1.6-.9-3-2.4-3.6 M12 15.6V21 M12 18c-1.8 0-3.2-1-3.8-2.4 M12 18.6c1.8 0 3.2-1 3.8-2.4' }
    ]},
    { cat:lorT('NATURE & SEASONS'), items:[
      { id:'snowflake', label:lorT('Snowflake'), name:'snowflake winter christmas', d:'M12 2.6v18.8 M3.9 7.3l16.2 9.4 M20.1 7.3L3.9 16.7 M12 6l-2.4-2.4M12 6l2.4-2.4 M12 18l-2.4 2.4M12 18l2.4 2.4 M6.9 9l-3.3-.9M6.9 9l-.9-3.3 M17.1 15l3.3.9M17.1 15l.9 3.3 M17.1 9l3.3-.9M17.1 9l.9-3.3 M6.9 15l-3.3.9M6.9 15l-.9 3.3' },
      { id:'tree', label:lorT('Tree'),      name:'tree christmas pine xmas fir christmas tree',       d:'M12 2.6L7 9h3L6 15h4l-3.4 4.6h10.8L14 15h4l-4-6h3z M12 19.6V22' },
      { id:'star', label:lorT('Star'),      name:'star sky night wish',       d:'M12 2.8l2.9 6 6.5.9-4.7 4.6 1.1 6.5L12 17.7l-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9z' },
      { id:'sun', label:lorT('Sun'),       name:'sun summer light',          d:'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M12 2.6v2.6M12 18.8v2.6M2.6 12h2.6M18.8 12h2.6M5.3 5.3l1.9 1.9M16.8 16.8l1.9 1.9M18.7 5.3l-1.9 1.9M7.2 16.8l-1.9 1.9' },
      { id:'leaf', label:lorT('Leaf'),      name:'leaf autumn nature',        d:'M4.4 19.6C3 14 6 5.6 19.6 4.4 20.8 18 12.4 21 6.8 19.6 M4.4 19.6C7.6 16 11 13.2 16.4 11' },
      { id:'butterfly', label:lorT('Butterfly'), name:'butterfly change beauty',   d:'M12 6.6v10.8 M12 8.8C10.4 5.6 7 4.2 5 5.6c-2 1.4-1.4 5 .6 6.6-2 1-2.6 3.8-1 5.2 1.8 1.6 5.6.4 7.4-3.4 M12 8.8c1.6-3.2 5-4.6 7-3.2 2 1.4 1.4 5-.6 6.6 2 1 2.6 3.8 1 5.2-1.8 1.6-5.6.4-7.4-3.4 M12 6.6l-1.4-2M12 6.6l1.4-2' },
      { id:'moon', label:lorT('Crescent moon'),      name:'moon crescent night calm',  d:'M20.2 14.8A8.5 8.5 0 0 1 9.2 3.8 8.5 8.5 0 1 0 20.2 14.8z' },
      { id:'tree-life', label:lorT('Tree of life'), name:'tree of life family roots', d:'M12 21.2v-7 M12 14.4c-3.5 0-6.2-2.7-6.2-5.8S8.5 2.8 12 2.8s6.2 2.6 6.2 5.8-2.7 5.8-6.2 5.8z M12 14.4l-3.1-3.4M12 14.4l3.1-3.4M12 11V7.4' },
      { id:'ladybug', label:lorT('Ladybug'), name:'ladybug boruze luck lucky beetle bug', d:'M12 6a6.2 7 0 1 0 0 14 6.2 7 0 1 0 0-14Z M12 6v14 M9.6 7.4a3.2 2.4 0 0 1 4.8 0 M10 11a1 1 0 1 1-2 0 1 1 0 1 1 2 0Z M16 11a1 1 0 1 1-2 0 1 1 0 1 1 2 0Z M10.4 15.6a1 1 0 1 1-2 0 1 1 0 1 1 2 0Z M15.6 15.6a1 1 0 1 1-2 0 1 1 0 1 1 2 0Z' },
      { id:'acorn', label:lorT('Acorn'), name:'acorn oak azuolas strength nut autumn oak leaf', d:'M6.5 9.5a5.5 3.2 0 0 1 11 0Z M6.5 9.5h11 M7.6 9.5c0 5 1.9 9.3 4.4 9.3s4.4-4.3 4.4-9.3 M12 6.3V4' },
    ]},
    { cat:lorT('PERSONAL'), items:[
      { id:'crown', label:lorT('Crown'),    name:'crown queen king royal',    d:'M3.4 18.6h17.2L19 8.4l-4.6 4.4L12 5l-2.4 7.8L5 8.4z M3.4 18.6V21h17.2v-2.4' },
      { id:'clover', label:lorT('Clover'),   name:'clover luck prosperity four leaf shamrock lucky luck',    d:'M12 12c0-2.4 1.2-4 3-4a2.6 2.6 0 0 1 0 5.2 M12 12c2.4 0 4 1.2 4 3a2.6 2.6 0 0 1-5.2 0 M12 12c0 2.4-1.2 4-3 4a2.6 2.6 0 0 1 0-5.2 M12 12c-2.4 0-4-1.2-4-3a2.6 2.6 0 0 1 5.2 0 M13 13.4c1.8 2.4 3 4.8 3.4 7.6' },
      { id:'anchor', label:lorT('Anchor'),   name:'anchor sea sailor hope',    d:'M12 7.6V21 M12 7.6a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z M7 10.4h10 M4 14.4c0 4 3.6 6.6 8 6.6s8-2.6 8-6.6' },
      { id:'feather', label:lorT('Feather'),  name:'feather light memory',      d:'M19.6 4.4C16.2 1 8 3 6 9.6 4.6 14 5.8 17 5.8 17S9.4 18.6 13.4 17c5.8-2.3 7.4-9.6 6.2-12.6z M4 20l7.6-7.6 M9.6 13.4h4.6 M12.6 10.4h4' },
      { id:'music', label:lorT('Music note'),    name:'music note song melody',    d:'M9.4 18.2V5.8l9.2-2v12.4 M9.4 18.2a2.6 2.2 0 1 1-2.6-2.2 M18.6 16.2a2.6 2.2 0 1 1-2.6-2.2 M9.4 9.6l9.2-2' },
      { id:'mountain', label:lorT('Mountain'), name:'mountain peak journey',     d:'M2.6 19.4h18.8L14.4 6.6l-3.6 6.2-2.2-3z M10.8 12.8l2 3.4' },
      { id:'wave', label:lorT('Wave'),     name:'wave ocean sea surf',       d:'M2.6 9.4c2.4-2.6 4.8-2.6 7.2 0s4.8 2.6 7.2 0 4.4-2.4 4.4-2.4 M2.6 15.4c2.4-2.6 4.8-2.6 7.2 0s4.8 2.6 7.2 0 4.4-2.4 4.4-2.4' },
      { id:'key', label:lorT('Key'),      name:'key home first house',      d:'M14.6 9.4a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4z M11.6 8.4L3 17v4h4l1-2h2v-2h2l1.6-1.6' }
    ]},
    { cat:lorT('CONNECTIONS'), items:[
      { id:'link', label:lorT('Chain link'),      name:'link chain connected',     d:'M10.4 13.6a3.6 3.6 0 0 0 5.4.4l2.4-2.4a3.6 3.6 0 0 0-5.1-5.1l-1.4 1.4 M13.6 10.4a3.6 3.6 0 0 0-5.4-.4l-2.4 2.4a3.6 3.6 0 0 0 5.1 5.1l1.4-1.4' },
      { id:'hands', label:lorT('Holding hands'),     name:'hands hold together care', d:'M4 12.6l3.4-3.4a1.6 1.6 0 0 1 2.3 2.3L8 13.2l3.4 3.4a2 2 0 0 0 2.8 0l5-5 M20 12.6l-3.4-3.4a1.6 1.6 0 0 0-2.3 2.3' },
      { id:'arrows', label:lorT('Two arrows'),    name:'arrows two directions',    d:'M3.4 9.4h13.2l-3-3 M20.6 14.6H7.4l3 3' }
    ]},
    { cat:lorT('FAITH & PROTECTION'), items:[
      { id:'cross', label:lorT('Cross'),     name:'cross faith christian',       d:'M12 3.2v17.6 M6.6 8.6h10.8' },
      { id:'evil-eye', label:lorT('Evil eye'),  name:'evil eye protection nazar',   d:'M2.9 12s3.5-5.3 9.1-5.3S21.1 12 21.1 12s-3.5 5.3-9.1 5.3S2.9 12 2.9 12z M12 14.7a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4z' },
      { id:'hamsa', label:lorT('Hamsa hand'),     name:'hamsa hand protection',       d:'M8.2 12V6.6a1.5 1.5 0 0 1 3 0V12 M11.2 12V4.8a1.5 1.5 0 0 1 3 0V12 M14.2 12V6.6a1.5 1.5 0 0 1 3 0v6 M8.2 12V9.2a1.5 1.5 0 0 0-3 0v3.6c0 4 3 7.2 6.8 7.2s6.8-3.2 6.8-7.2 M12 15.8a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2z' },
      { id:'lotus', label:lorT('Lotus'),     name:'lotus calm peace balance flower',    d:'M12 20.4c-2.7 0-4.8-2.7-4.8-5.8 0-3.5 4.8-7.2 4.8-7.2s4.8 3.7 4.8 7.2c0 3.1-2.1 5.8-4.8 5.8z M12 20.4c-4.7 0-8.6-2.4-8.6-5.3 0-1 .7-1.8 1.7-1.8 1.5 0 2.8 1.5 2.8 1.5 M12 20.4c4.7 0 8.6-2.4 8.6-5.3 0-1-.7-1.8-1.7-1.8-1.5 0-2.8 1.5-2.8 1.5' },
      { id:'wings', label:lorT('Angel wings'),     name:'angel wings memory guardian', d:'M12 4.6v15 M11 8.2C8.5 5.8 5.2 4.8 3 5.2c-.6 3.5 1.1 7.6 4.1 9.4 M13 8.2c2.5-2.4 5.8-3.4 8-3 .6 3.5-1.1 7.6-4.1 9.4' },
      { id:'auseklis', label:lorT('Auseklis'), name:'auseklis morning star latvian protection folk baltic', d:'M12 2.5 21.5 12 12 21.5 2.5 12Z M5.2 5.2H18.8V18.8H5.2Z' },
      { id:'sun-cross', label:lorT('Sun cross'), name:'sun cross baltic folk light life pērkons', d:'M12 4a8 8 0 1 0 0 16 8 8 0 1 0 0-16Z M12 4v16 M4 12h16' },
    ]},
    { cat:lorT('MILESTONES'), items:[
      { id:'cake', label:lorT('Birthday cake'),      name:'cake birthday anniversary birthday',   d:'M4.2 20.6h15.6v-5.2c0-1-.8-1.8-1.8-1.8H6c-1 0-1.8.8-1.8 1.8z M4.2 17.2c1.6 1.2 3.2 1.2 4.8 0s3.2-1.2 4.8 0 3.2 1.2 4.8 0 M8.4 13.6V10 M12 13.6V9.4 M15.6 13.6V10 M8.4 7.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z M12 7.2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z M15.6 7.8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' },
      { id:'plane', label:lorT('Plane'),     name:'plane travel journey trip',   d:'M21 3.2L3.4 10.8l7 2.6M21 3.2l-7.4 17.6-3.2-7.4M21 3.2L10.4 13.4' },
      { id:'graduate', label:lorT('Graduation cap'),  name:'graduation school diploma',   d:'M12 3.6L2.8 8.2 12 12.8l9.2-4.6z M6.6 10.6v4.8c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.8 M21.2 8.2v6.2' },
      { id:'house', label:lorT('House'),     name:'house home new first',        d:'M3.6 10.9L12 4l8.4 6.9v9.3H3.6z M9.6 20.2v-6h4.8v6' },
      { id:'date', label:lorT('Calendar'),      name:'date calendar day remember wedding anniversary',  d:'M4.6 6.8h14.8v13.4H4.6z M4.6 10.9h14.8 M8.6 3.8v4M15.4 3.8v4' }
    ]}
  ];

  var ALL_ICONS = LIB.reduce(function(a,c){ return a.concat(c.items); }, []);
  function iconById(id){ for(var i=0;i<ALL_ICONS.length;i++){ if(ALL_ICONS[i].id===id) return ALL_ICONS[i]; } return null; }
  function iconSvg(ic){
    /* a filled symbol must LOOK filled in the tray, or she picks an outline and
       receives a solid - the one place the tray must not lie. */
    var st = ic.fill ? ' style="fill:currentColor;stroke:none"' : '';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+ic.d+'"'+st+'></path></svg>';
  }
  /* Two KINDS of symbol, not one. An outline is a centreline the laser walks, which the
     workshop pipeline buffers into a 0.24 mm ribbon so it shows on silver. A `fill`
     symbol is a closed area the laser HATCHES - solid, and far more legible on a small
     face, which is why the owner asked for it (2026-09-21). The two must never be
     confused downstream: buffering a filled heart into a ribbon turns it back into an
     outline, so build_ribbons.py skips them and their contour goes straight to PLT. */
  function drawIcon(g, id, cx, cy, size, colour){
    var ic = iconById(id); if(!ic) return;
    g.save(); g.translate(cx-size/2, cy-size/2); g.scale(size/24, size/24);
    if(ic.fill){
      g.fillStyle = colour; g.strokeStyle = 'transparent';
      g.fill(new Path2D(ic.d));
    } else {
      g.strokeStyle = colour; g.fillStyle = 'transparent';
      g.lineWidth = 1.5; g.lineCap='round'; g.lineJoin='round';
      g.stroke(new Path2D(ic.d));
    }
    g.restore();
  }

  function roundRect(g,x,y,w,h,r){g.beginPath();g.moveTo(x+r,y);g.arcTo(x+w,y,x+w,y+h,r);g.arcTo(x+w,y+h,x,y+h,r);g.arcTo(x,y+h,x,y,r);g.arcTo(x,y,x+w,y,r);g.closePath();}

  /* ONE path routine for the shape, shared by preview and final render */
  function pathIn(g, sh, bx, by, bw, bh){
    var cx = bx + bw/2, cy = by + bh/2;
    if(sh==='coin'){ g.beginPath(); g.arc(cx, cy, Math.min(bw,bh)/2, 0, Math.PI*2); g.closePath(); return; }
    if(sh==='heart'){
      /* A Bezier never reaches its control points, so the old offsets - +/-0.56 bw, tip at
         0.40 bh - drew a heart only 75.3% as wide and 69.8% as tall as the box it was
         given, while the coin, bar and rect all fill theirs exactly. On the photo heart
         necklace that left the engraving at 67% of the pendant's width with a broad silver
         margin round it. Owner, 2026-09-21: "the heart doesnt fit the item, the form very
         small then the real item", then a screenshot of the coin, whose photo fills the
         disc: "like this example".

         Same silhouette, scaled so its real extremes land on the box edges: solved from
         the curve, not guessed. Measured 0.7527 wide against 346/459 = 0.754 on the live
         canvas, so the model and the metal agree. Width x1.33, height x1.43, area x1.90.

         This is the path renderEngraving() clips too, so the piece itself is marked
         larger - that is the point, not a side effect. */
      g.beginPath();
      g.moveTo(cx, cy + bh*0.500);
      g.bezierCurveTo(cx - bw*0.744, cy - bh*0.159, cx - bw*0.585, cy - bh*0.819, cx, cy - bh*0.331);
      g.bezierCurveTo(cx + bw*0.585, cy - bh*0.819, cx + bw*0.744, cy - bh*0.159, cx, cy + bh*0.500);
      g.closePath(); return;
    }
    var r = sh==='bar' ? bh/2 : (sh==='rect' ? 10 : PLATE.r);
    roundRect(g, bx, by, bw, bh, r);
  }
  function box(inset){
    var d = SHAPES[shape];
    var w = PLATE.s*d.w + (inset||0)*2, h = PLATE.s*d.h + (inset||0)*2;
    return { x: PLATE.x + PLATE.s/2 - w/2, y: PLATE.y + PLATE.s/2 - h/2, w:w, h:h };
  }
  function platePath(g, inset){ var b=box(inset); pathIn(g, shape, b.x, b.y, b.w, b.h); }
  window.__lorProbe = window.__lorProbe || {};
  /* the box TEXT is allowed, inside the box the piece occupies */
  function textBox(bx, by, bw, bh){
    var k = SHAPES[shape].ti || 1;
    return { x: bx + bw*(1-k)/2, y: by + bh*(1-k)/2, w: bw*k, h: bh*k };
  }
  /* ---------------- one tone, on every engine ----------------
     The grey was left entirely to ctx.filter. Safari on iOS before 17 does not implement
     CanvasRenderingContext2D.filter at all: the assignment is IGNORED - no error, no
     warning - so the photo was drawn in full colour, in the preview AND in the 900px file
     that goes to the laser. Measured 2026-09-22 on renderAt('front',900): 533,129 of
     810,000 pixels coloured, 65.8%. Five of six sales come from a phone.
     So the tone is no longer trusted to the engine. Where filter exists it is used exactly
     as before, which keeps the desktop file byte-for-byte what it was; where it does not,
     the same three steps run over the pixels instead. Checked against Chromium's own
     filter on nine colours: largest difference 2 of 255, which is its own rounding. */
  var MONO = 'grayscale(1) contrast(2.4) brightness(1.08)';
  var FILTER_OK = (function(){
    try {
      var c = document.createElement('canvas').getContext('2d');
      c.filter = MONO;
      return !!c.filter && c.filter !== 'none';
    } catch(e){ return false; }
  })();
  var monoCv = null;
  function monoDraw(g, img, x, y, w, h){
    if(FILTER_OK){
      g.filter = MONO;
      g.drawImage(img, x, y, w, h);
      g.filter = 'none';
      return;
    }
    var W = Math.max(1, Math.round(w)), H = Math.max(1, Math.round(h));
    if(!monoCv) monoCv = document.createElement('canvas');
    if(monoCv.width !== W || monoCv.height !== H){ monoCv.width = W; monoCv.height = H; }
    var mg = monoCv.getContext('2d', { willReadFrequently: true });
    mg.clearRect(0, 0, W, H);
    mg.drawImage(img, 0, 0, W, H);
    try {
      var d = mg.getImageData(0, 0, W, H), p = d.data, i, l;
      for(i = 0; i < p.length; i += 4){
        l = (0.2126*p[i] + 0.7152*p[i+1] + 0.0722*p[i+2]) / 255;   /* grayscale(1) */
        l = (l - 0.5) * 2.4 + 0.5;                                  /* contrast(2.4) */
        l = l * 1.08 * 255;                                         /* brightness(1.08) */
        l = l < 0 ? 0 : (l > 255 ? 255 : l);
        p[i] = p[i+1] = p[i+2] = l;
      }
      mg.putImageData(d, 0, 0);
    } catch(e){
      /* Only a tainted canvas can land here, and the customer's upload is a blob URL
         which never taints - but drawing colour in silence is the very bug being fixed,
         so it is recorded rather than swallowed. */
      if(window.__lorProbe) window.__lorProbe.monoFailed = true;
    }
    g.drawImage(monoCv, x, y, W, H);
  }

  function artRect(st, bx, by, bw, bh){
    var fit = Math.min(bw,bh)/SHAPES[shape].fit;
    var sd  = fit*st.zoom;
    var k   = bw/(PLATE.s*SHAPES[shape].w);
    return { x: bx+(bw-sd)/2 + st.off.x*k, y: by+(bh-sd)/2 + st.off.y*k, s: sd };
  }

  /* ONE layout routine for text + symbol, shared by the live preview and the
     final render - exactly like pathIn() for the shape. Two copies is how the
     two could silently drift apart.
     `caret` is an out-parameter: the editor asks where the cursor belongs, the
     final render never does. */
  function drawTextIcon(g, st, bx, by, bw, bh, colour, minFs, caret){
    var t = st.text, hasT = !!t, hasI = !!st.icon;
    var mid  = shape==='heart' ? by+bh*0.44 : by+bh/2;
    /* 0.22 of the box HEIGHT was right only for a face as tall as it is wide. fitTo()
       below shrinks but never grows, so on a shallow face the type could never recover:
       a signet plate measured 215x66 gave a box 47px tall, fs fell to 10 and was then
       clamped at minFs, which is why the plate's depth stopped mattering at all. The
       bar was worse - 42px of type in a 191px box, 18% of the width it could carry.
       0.62 lets a single line use a sensible share of the height and leaves fitTo to
       bring it back to the width. Measured across all sixteen products on 2026-09-18,
       6- and 12-letter names: nothing shrinks, nothing overflows (44% of box height at
       worst), 12-letter names are already width-limited so they do not move, and the
       starved shapes recover - rect 48%->100%, bar 36%->100%. */
    var fs   = Math.max(minFs, Math.round(bh*0.62*(st.scale||1)));
    var fsWanted = fs;                /* what her slider asked for, before any capping */
    var maxW = bw*SHAPES[shape].fit;
    var pos  = st.iconPos || 'above';

    g.fillStyle = colour;
    g.textAlign = 'center'; g.textBaseline = 'middle';

    /* Canvas fillText(..., maxWidth) does NOT shrink the type -- it CONDENSES the
       glyphs horizontally. Measured on 2026-09-18: a Montserrat H kept its 3.05 mm
       height at every length while its width collapsed from 104 px at one letter to
       51 px at twelve, i.e. half its true width, and that distortion was going
       straight to the laser. So set a font size that genuinely fits, and never pass
       maxWidth to fillText again. */
    function setFont(size){ g.font = '400 '+size+'px "'+st.font+'", Georgia, serif'; }
    /* The WIDTH was always guarded: fitTo shrinks the type until it fits maxW. The HEIGHT
       never was, and that is the gap the owner found on 2026-09-21 ("if user make the size
       bigger can make issue?"). A single letter is never wide enough for fitTo to touch,
       so at the top of the slider fs reaches about 0.99 of the box height and the glyph is
       taller than the face. The mark still cannot leave the plate -- the canvas is clipped
       -- so what she got instead was a letter with its top sliced flat, and no warning.
       Measured live on the coin: "A" at SIZE 160, apex cut clean off.

       Cap on the REAL drawn height, not on font size: a script face and a slab face at the
       same fs differ enormously, so fs alone does not tell you whether it fits. */
    function capH(str){
      setFont(fs);
      var m = g.measureText(str), h;
      if(m.actualBoundingBoxAscent != null && m.actualBoundingBoxDescent != null)
        h = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
      else h = fs * 0.72;                     /* older engines: the usual cap+descender */
      var room = bh * 0.92;                   /* a hair of margin so it never kisses the rim */
      if(h > room && h > 0){
        fs = Math.max(minFs, Math.floor(fs * room / h));
        setFont(fs);
        return true;
      }
      return false;
    }
    function fitTo(str, room){
      var capped = capH(str);
      setFont(fs);
      var w = g.measureText(str).width;
      if(w > room && w > 0){
        fs = Math.max(minFs, Math.floor(fs * room / w));
        setFont(fs);
        capped = true;
      }
      /* Remembered only for the LIVE canvas, so sync() can tell her the slider has
         stopped doing anything instead of letting her drag on into a sliced letter.
         caret is non-null only on the canvas she is looking at. */
      if(caret) LOR_FIT = { wanted: fsWanted, got: fs, capped: capped };
      return g.measureText(str).width;
    }
    setFont(fs);

    function mark(x, y){ if(caret){ caret.x = x; caret.y = y; caret.h = fs*0.92; } }

    if(!hasT && !hasI){ mark(bx+bw/2, mid); return; }

    if(hasI && !hasT){
      drawIcon(g, st.icon, bx+bw/2, mid, Math.min(bw,bh)*0.42*(st.scale||1), colour);
      mark(bx+bw/2, mid); return;
    }
    if(!hasI){
      var w0 = fitTo(t, maxW);
      g.fillText(t, bx+bw/2, mid);
      mark(bx + bw/2 + w0/2 + fs*0.10, mid);
      return;
    }

    /* One slider drove two things that do not scale together. The symbol was multiplied
       and never fitted, while the text was fitted into what the symbol left over -
       so dragging SIZE from 100 to 160 on a coin grew the symbol 60% and shrank the
       name from fs 86 to fs 54. The control ran backwards for the thing she was
       looking at. Capping the symbol's share of the row removes that inversion without
       touching the fitter, which every one of the sixteen layouts depends on. */
    /* Above and Below, the symbol and the name sit on separate lines and scaling both
       is what she asked for. BEFORE and AFTER put them on ONE line, so every pixel the
       symbol gains is a pixel the name loses - and the name is what she is watching.
       Measured on the coin with "ELZ": SIZE 60 gave 20,617 ink pixels and SIZE 100 gave
       15,727, so dragging the control up made her name smaller. Inline, the symbol now
       holds a fixed share and the slider speaks only to the text. The 28% cap stays as
       a second guard for a shape whose face is unusually narrow. */
    var inlineSym = (pos === 'beside' || pos === 'before' || pos === 'after');
    var isz = Math.min(bw,bh) * 0.22 * (inlineSym ? 1 : (st.scale||1));
    if(inlineSym) isz = Math.min(isz, maxW*0.28);

    /* A.6 - the stack has to fit the box HEIGHT as well as its width. Before this the
       symbol sat at a fixed `mid - fs*0.75` while fs became 0.62 of the box height
       (raised 2026-09-18 for text alone), so on a shallow face the symbol ran off the
       plate - in the preview AND in the 900 px file the workshop marks from, which
       clips identically. Scale the whole row down together; if even that will not fit,
       two rows are impossible on this face, so move the symbol inline and say so
       rather than cutting it in half. */
    if(pos === 'above' || pos === 'below'){
      var sgap = fs*0.10, total = isz + sgap + fs;
      if(total > bh){
        var kf = bh/total;
        fs = Math.max(minFs, Math.floor(fs*kf)); isz = isz*kf; setFont(fs);
        total = isz + sgap + fs;
      }
      window.__lorProbe.stackCalc = { isz:isz, fs:fs, bh:bh, total:total,
                                      ratio:isz/fs, floor:bh*0.10 };
      /* ⚠️ The spec proposed `isz < fs*0.40` here. Measured against THIS file's
         constants that rejects every shape: isz is 0.22*min(w,h) and fs is 0.62*bh,
         so the natural ratio is 0.355 - permanently under 0.40. Applying it as written
         forced all five products inline and killed the Above/Below layout outright.
         The real condition for "two rows are impossible" is the one above: the stack
         still overruns the height after rescaling, because minFs clamped it. The
         second clause only needs to stop the symbol becoming a speck, so it is an
         absolute share of the face, not a ratio to the type. */
      if(total > bh || isz < bh*0.10){
        /* Fall back to one inline row - and reset both sizes to the inline rule,
           because fs and isz may already have been shrunk above. */
        st._forcedInline = true;
        pos = 'before';
        fs = Math.max(minFs, Math.round(bh*0.62*(st.scale||1))); setFont(fs);
        isz = Math.min(Math.min(bw,bh)*0.22, maxW*0.28);
      } else {
        st._forcedInline = false;
        var wS = fitTo(t, maxW);
        total = isz + sgap + fs;
        var top = mid - total/2;
        if(pos === 'above'){
          drawIcon(g, st.icon, bx+bw/2, top + isz/2, isz, colour);
          g.fillText(t, bx+bw/2, top + isz + sgap + fs/2);
          mark(bx + bw/2 + wS/2 + fs*0.10, top + isz + sgap + fs/2);
        } else {
          g.fillText(t, bx+bw/2, top + fs/2);
          drawIcon(g, st.icon, bx+bw/2, top + fs + sgap + isz/2, isz, colour);
          mark(bx + bw/2 + wS/2 + fs*0.10, top + fs/2);
        }
        window.__lorProbe.stack = { isz:isz, fs:fs, gap:sgap, total:total, bh:bh, top:top-by };
        return;
      }
    } else { st._forcedInline = false; }
    /* One inline row, symbol on either end of the words. It used to be a single
       position called 'beside', which always drew the symbol BEFORE the text; the
       owner saw the empty space after his name on 2026-09-19 and asked for that side
       too, so 'beside' became 'before' and 'after' joined it. The old name still
       draws, so a piece configured before the change is never left blank.
       Both share one measurement: the row is icon + gap + text either way, so the
       text is fitted to the same room and only the two x positions swap. */
    if(pos === 'beside' || pos === 'before' || pos === 'after'){
      /* Size the symbol off the TEXT, not off the box. It was 0.22 of the box's shorter
         side, which on a bar or a cuff IS the plate's shallow height -- so the symbol came
         out roughly a quarter of the letters standing right next to it. Owner, 2026-09-21,
         looking at his own cuff: "the text is big and the symbol is small".
         Beside the words a symbol is read as one of them, so it should stand about as tall
         as they do; 0.78 of the font size lands on the cap height of these faces.
         Two passes, because the two sizes depend on each other: fit the text with the old
         estimate to learn what size it really lands at, size the symbol from that, then fit
         once more in the room that leaves. fitTo only ever shrinks, so this cannot grow the
         text past the plate. Above/Below keep the box measure: there the symbol is a row of
         its own, not a neighbour to the letters. */
      var gap = isz*0.34;
      fitTo(t, maxW - isz - gap);
      isz = Math.min(fs * 0.78, bh * 0.92);
      gap = isz*0.34;
      var tw  = fitTo(t, maxW - isz - gap);
      var left = bx + bw/2 - (isz + gap + tw)/2;
      var iconFirst = pos !== 'after';
      var iconX = iconFirst ? left + isz/2 : left + tw + gap + isz/2;
      var textX = iconFirst ? left + isz + gap : left;
      window.__lorProbe.inline = { fs:fs, room:maxW - isz - gap, maxW:maxW, isz:isz, gap:gap };
      drawIcon(g, st.icon, iconX, mid, isz, colour);
      g.textAlign = 'left';
      g.fillText(t, textX, mid);
      g.textAlign = 'center';
      mark(textX + tw + fs*0.10, mid);
    }
    /* `above` and `below` return from the stack block above; anything reaching here is
       inline, including a stack that was forced inline by a face too shallow for two rows. */
  }

  /* C.5 - what "Left"/"Right" costs, computed before she pays it.
     Inline, the symbol and the name share ONE row, so every pixel the symbol takes is
     a pixel the name loses; Above and Below give the name the whole width. The layout
     already knows the number - nothing else did. Measured on an offscreen context so
     it can run from sync() without touching either visible canvas. */
  var _costCv = null;
  function inlineCost(st){
    if(!st.icon || !clean(st.text)) return null;
    if(!_costCv) _costCv = document.createElement('canvas');
    var g = _costCv.getContext('2d');
    var R = 900, d = SHAPES[shape], m = Math.max(d.w, d.h), pad = R*0.05;
    var bw = (R-pad*2)*(d.w/m), bh = (R-pad*2)*(d.h/m);
    var maxW = bw*d.fit, minFs = 20, t = clean(st.text);
    function fitIn(room){
      var fs = Math.max(minFs, Math.round(bh*0.62*(st.scale||1)));
      g.font = '400 '+fs+'px "'+st.font+'", Georgia, serif';
      var w = g.measureText(t).width;
      if(w > room && w > 0){ fs = Math.max(minFs, Math.floor(fs*room/w)); }
      return fs;
    }
    var isz = Math.min(Math.min(bw,bh)*0.22, maxW*0.28), gap = isz*0.34;
    var fsAbove = fitIn(maxW), fsInline = fitIn(maxW - isz - gap);
    if(!fsAbove) return null;
    /* how many characters the symbol eats, in the customer's own units */
    g.font = '400 '+fsInline+'px "'+st.font+'", Georgia, serif';
    var per = g.measureText(t).width / Math.max(1, t.length);
    return { ratio: fsInline/fsAbove,
             pct: Math.round((1 - fsInline/fsAbove)*100),
             chars: Math.max(1, Math.round((isz+gap)/Math.max(1,per))) };
  }

  /* one painter for both canvases. `live` adds the blinking caret, which must
     never reach the file the workshop receives. */
  /* the engraving drawn onto the product's own photograph */
  function paintOnPhoto(g, st, slot, live){
    var CW = g.canvas.width, CH = g.canvas.height;
    var f = photoFace(slot, CW, CH);
    g.drawImage(slot.img, f.sx, f.sy, f.sw, f.sh, f.dx, f.dy, f.dw, f.dh);

    var caret = live ? {x:0,y:0,h:0} : null;
    g.save();
    g.beginPath();
    /* A.7 - this was an ellipse for EVERY product, while renderEngraving() clips to the
       product's own outline around its own layout box. So a photo framed inside a heart
       was previewed inside an oval, and the customer positioned her picture against a
       boundary the workshop never cuts. Clipping the same box the art is laid out in
       (f.B) makes preview and render one geometry - the argument pathIn() and
       drawTextIcon() already make for themselves two lines below. */
    var msk = (st.mode==='photo' && st.art) ? silhouette(slot) : null;
    /* with a mask the metal itself is the boundary, so the clip only has to keep the
       engraving off the bail and the chain - that is what the face rectangle does. */
    if(msk) g.rect(f.B.x, f.B.y, f.B.w, f.B.h);
    else    pathIn(g, shape, f.B.x, f.B.y, f.B.w, f.B.h);
    g.clip();
    if(st.mode==='photo' && st.art){
      var a = artRect(st, f.B.x, f.B.y, f.B.w, f.B.h);
      window.__lorProbe.previewArt = { s:a.s, w:f.B.w, h:f.B.h, x:a.x-f.B.x, y:a.y-f.B.y, masked:!!msk };
      if(msk){
        var tmp = document.createElement('canvas'); tmp.width = CW; tmp.height = CH;
        var tg = tmp.getContext('2d');
        monoDraw(tg, st.art, a.x, a.y, a.s, a.s);
        tg.globalCompositeOperation='destination-in';
        tg.drawImage(msk, f.sx, f.sy, f.sw, f.sh, f.dx, f.dy, f.dw, f.dh);
        g.globalCompositeOperation='multiply'; g.globalAlpha=0.9;
        g.drawImage(tmp, 0, 0);
        g.globalCompositeOperation='source-over'; g.globalAlpha=1;
      } else {
        g.globalCompositeOperation='multiply'; g.globalAlpha=0.9;
        monoDraw(g, st.art, a.x, a.y, a.s, a.s);
        g.globalCompositeOperation='source-over'; g.globalAlpha=1;
      }
    }
    if(st.mode==='text'){
      g.globalCompositeOperation='multiply';
      var TB = textBox(f.B.x, f.B.y, f.B.w, f.B.h);
      drawTextIcon(g, st, TB.x, TB.y, TB.w, TB.h, '#555B62', 11, caret);
      g.globalCompositeOperation='source-over';
      if(live && typing && caretOn){
        g.strokeStyle='#006039'; g.lineWidth=2; g.lineCap='butt';
        g.beginPath(); g.moveTo(caret.x, caret.y-caret.h/2); g.lineTo(caret.x, caret.y+caret.h/2); g.stroke();
      }
    }
    g.restore();

    /* The boundary was invisible, so "will my face be cut off?" had no answer on screen.
       Gold, because it is the brand's accent and never the engraving's own colour.

       It is now drawn for TEXT as well, not only under a photo. Owner, 2026-09-21, after
       fifteen characters ran off the end of a bar: "add visible canvas line ... that user
       cannot across it even user make size of the text bigger", with a Pandora tag as the
       example -- a dashed rectangle printed over the plate.

       Dashed, so it reads as a guide and never as part of the engraving.

       TEXT ONLY. It was drawn under a photo too, solid, on the argument that there it is
       the crop edge she drags against. Owner, 2026-09-21: "it should be free for user to
       move the images, its applicable only for text". The limit was asked for because
       TYPE GROWS off the plate; a photo is dragged on purpose, and a line over it reads
       as a refusal. The photo needs no line either way - it is clipped to the piece, so
       the edge of the picture she can see already IS the crop edge.

       The clip itself stays: nothing outside the metal can be marked, and showing it
       would make the preview lie about what ships. Free to move, not free to overrun.

       This is the SAME f.B the engraving is clipped to two blocks above, so the line is
       not a drawing of the limit -- it IS the limit. Nothing can cross it at any size.

       live only. The workshop file must never carry a guide line, and neither should any
       image we store, so this is barred from every canvas except the one on screen. */
    if(live && (st.mode === 'text' || typing)){
      g.save();
      g.beginPath();
      var GB = textBox(f.B.x, f.B.y, f.B.w, f.B.h);
      pathIn(g, shape, GB.x, GB.y, GB.w, GB.h);
      g.strokeStyle = '#A37E2C';
      g.lineWidth = Math.max(1.5, CW/320);
      g.setLineDash([Math.max(5, CW/70), Math.max(4, CW/100)]);
      g.globalAlpha = typing ? 0.9 : 0.55;
      g.stroke();
      g.restore();
    }

    g.fillStyle='#9AA0A6'; g.font='700 12px Manrope, system-ui, sans-serif'; g.textAlign='center';
    g.fillText((SIDES===1 ? '' : lorT(side==='front'?lorT('FRONT'):lorT('BACK'))+' · ')+lorT('YOUR ACTUAL PIECE'), CW/2, CH-14);
  }

  function paint(g, live){
    var st = cur();
    g.clearRect(0,0,g.canvas.width,g.canvas.height);

    var slot = productPhoto();
    if(slot){ paintOnPhoto(g, st, slot, live); return; }

    g.strokeStyle='#B9BCC0'; g.lineWidth=7; g.lineCap='round'; g.setLineDash([3,6]);
    g.beginPath(); g.moveTo(80,20);  g.bezierCurveTo(110,200,195,270,220,300); g.stroke();
    g.beginPath(); g.moveTo(360,20); g.bezierCurveTo(330,200,245,270,220,300); g.stroke();
    g.setLineDash([]);

    var lg = g.createLinearGradient(PLATE.x,PLATE.y,PLATE.x+PLATE.s,PLATE.y+PLATE.s);
    if(side === 'back'){ lg.addColorStop(0,'#EDEFF2'); lg.addColorStop(0.45,'#DADEE2'); lg.addColorStop(1,'#BFC4CA'); }
    else { lg.addColorStop(0,'#F4F6F8'); lg.addColorStop(0.45,'#E2E6EA'); lg.addColorStop(1,'#C7CCD1'); }
    platePath(g,5); g.fillStyle='#BFC4C9'; g.fill();
    platePath(g,0); g.fillStyle=lg; g.fill();

    var B = box(0), caret = live ? {x:0,y:0,h:0} : null;
    g.save(); platePath(g,0); g.clip();
    if(st.mode==='photo' && st.art){
      var a = artRect(st, B.x, B.y, B.w, B.h);
      g.globalCompositeOperation='multiply'; g.globalAlpha=0.9;
      monoDraw(g, st.art, a.x, a.y, a.s, a.s);
      g.globalCompositeOperation='source-over'; g.globalAlpha=1;
    }
    if(st.mode==='text'){
      g.globalCompositeOperation='multiply';
      var PB = textBox(B.x, B.y, B.w, B.h);
      drawTextIcon(g, st, PB.x, PB.y, PB.w, PB.h, '#4E545B', 13, caret);
      g.globalCompositeOperation='source-over';
      if(live && typing && caretOn){
        g.strokeStyle='#006039'; g.lineWidth=2; g.lineCap='butt';
        g.beginPath(); g.moveTo(caret.x, caret.y-caret.h/2); g.lineTo(caret.x, caret.y+caret.h/2); g.stroke();
      }
    }
    g.restore();

    g.save(); platePath(g,0); g.clip();
    var hg = g.createLinearGradient(0,B.y,0,B.y+B.h*0.5);
    hg.addColorStop(0,'rgba(255,255,255,.55)'); hg.addColorStop(1,'rgba(255,255,255,0)');
    g.fillStyle=hg; g.fillRect(B.x,B.y,B.w,B.h*0.5); g.restore();

    platePath(g,1); g.strokeStyle=BORDER[border]; g.lineWidth=2.5; g.stroke();

    g.fillStyle='#9AA0A6'; g.font='700 12px Manrope, system-ui, sans-serif'; g.textAlign='center';
    g.fillText((SIDES===1 ? '' : (side==='front'?lorT('FRONT'):lorT('BACK'))+' · ')+lorT('PREVIEW'),
               PLATE.x+PLATE.s/2, PLATE.y+PLATE.s+34);
  }

  /* ---------------------------------------------------------------
     THE FILE THE WORKSHOP RECEIVES — the finished engraving, cropped
     to the product's own shape at the customer's exact zoom and
     position, already one tone. Nothing left to interpret.
     --------------------------------------------------------------- */
  /* Whitespace is not an engraving. The preview keeps her spaces; the laser cannot cut
     them. Without this, a face holding only spaces counted as engraved everywhere: the
     cart line was marked personalised with an empty text property, the blank-piece nudge
     never fired, and the workshop received a job with nothing on it. */
  function clean(t){ return String(t == null ? '' : t).replace(/\s+/g, ' ').trim(); }

  /* `size` is optional and defaults to the 900 px the workshop file has always been.
     The proof panel asks for 256 instead: three synchronous 900x900 encodes at the
     moment a dialog opens is a visible stall on a phone, and the thumbnail is 96 px. */
  /* A.12 - split so pixels can be MEASURED without a PNG encode. `fill` paints the
     white ground for the workshop file; the measuring pass leaves it transparent so
     everything outside the piece can be skipped by alpha. */
  function renderCanvas(key, size, fill){
    var st = S[key];
    if(st.mode==='none') return null;
    if(st.mode==='photo' && !st.art) return null;
    if(st.mode==='text' && !clean(st.text) && !st.icon) return null;

    var R = size || 900, k = R / 900, oc = document.createElement('canvas');
    oc.width = R; oc.height = R;
    var g = oc.getContext('2d', {willReadFrequently: !fill});
    if(fill){ g.fillStyle = '#FFFFFF'; g.fillRect(0,0,R,R); }

    var d = SHAPES[shape], m = Math.max(d.w, d.h), pad = R*0.05;
    var bw = (R-pad*2)*(d.w/m), bh = (R-pad*2)*(d.h/m);
    var bx = (R-bw)/2, by = (R-bh)/2;

    g.save();
    /* the same outline the preview uses - see silhouette(). Two clips would be two
       different engravings. */
    var rslot = (st.mode==='photo') ? productPhoto() : null;
    var rmsk  = (rslot && rslot.ready) ? silhouette(rslot) : null;
    if(rmsk) g.rect(bx, by, bw, bh);
    else     pathIn(g, shape, bx, by, bw, bh);
    g.clip();
    if(st.mode==='photo'){
      var a = artRect(st, bx, by, bw, bh);
      window.__lorProbe.renderArt = { s:a.s, w:bw, h:bh, x:a.x-bx, y:a.y-by, masked:!!rmsk };
      if(rmsk){
        var fsrc = faceSrc(rslot);
        var rt = document.createElement('canvas'); rt.width = R; rt.height = R;
        var rg = rt.getContext('2d');
        monoDraw(rg, st.art, a.x, a.y, a.s, a.s);
        rg.globalCompositeOperation = 'destination-in';
        rg.drawImage(rmsk, fsrc.sx, fsrc.sy, fsrc.sw, fsrc.sh, bx, by, bw, bh);
        g.drawImage(rt, 0, 0);
      } else {
      monoDraw(g, st.art, a.x, a.y, a.s, a.s);
      }
    } else {
      /* minFs is a floor in device pixels, so it has to follow R or a 256 px proof
         would clamp its type at 20 px - 8% of the whole tile. k is exactly 1 at the
         900 px workshop size, which keeps that file byte-for-byte what it was. */
      var RB = textBox(bx, by, bw, bh);
      drawTextIcon(g, st, RB.x, RB.y, RB.w, RB.h, '#111111', 20 * k, null);
    }
    g.restore();
    /* The piece outline used to be stroked into this file. It is near-black, so the
       machine marked it: measured on the delivered BMP, a 2 px dark stripe on the disc's
       edge and 281 dark pixels in the outer annulus - a ring engraved round every
       photograph. Owner, 2026-09-22: "The image should be cut without a border".
       The outline still reaches the workshop, but as its own vector file that can be
       aligned to and deleted - see outline_plt() in watch_orders.py. */
    return oc;
  }

  function renderEngraving(key, size){
    var c = renderCanvas(key, size, true);
    return c ? c.toDataURL('image/png') : null;
  }

  /* The old analyse() squashed the WHOLE FILE into 64x64 once, at upload. So the
     verdict described a photo she was not engraving: crop, zoom and pan all change
     what the piece actually carries, and none of them re-ran the test. A face against
     a bright window can pass as a file and fail as a pendant.
     ⚠️ And stated plainly: `ok` gates NOTHING. A low-contrast photo still adds to
     cart - she is told, in numbers, and the choice stays hers. */
  function analyseFramed(key){
    var c = renderCanvas(key, 180, false); if(!c) return null;
    var d = c.getContext('2d',{willReadFrequently:true}).getImageData(0,0,180,180).data;
    var lum=[], sum=0;
    for(var i=0;i<d.length;i+=4){
      if(d[i+3] < 8) continue;                       /* outside the piece */
      var L = 0.2126*d[i] + 0.7152*d[i+1] + 0.0722*d[i+2]; lum.push(L); sum += L;
    }
    if(lum.length < 500) return null;
    var mean=sum/lum.length, v=0;
    for(var j=0;j<lum.length;j++){ v += (lum[j]-mean)*(lum[j]-mean); }
    var sd=Math.sqrt(v/lum.length);
    var srt=lum.slice().sort(function(a,b){return a-b;});
    var spread=srt[Math.floor(lum.length*0.95)] - srt[Math.floor(lum.length*0.05)];
    return { spread:spread, sd:sd, ok:(sd>=42 && spread>=120) };
  }

  /* Debounced: a drag fires this on release, not per frame. Size flags survive -
     they describe the FILE and cannot change by zooming. */
  var remeasureT = null;
  function remeasure(){
    clearTimeout(remeasureT);
    remeasureT = setTimeout(function(){
      var st = cur();
      if(st.mode !== 'photo' || !st.art || !st.verdict) return;
      var f = analyseFramed(side); if(!f) return;
      var was = st.verdict.ok;
      st.verdict.spread = f.spread; st.verdict.sd = f.sd; st.verdict.ok = f.ok;
      sync();
      if(was !== f.ok){
        var v = document.getElementById('verdict');
        if(v){ v.classList.remove('flip'); void v.offsetWidth; v.classList.add('flip'); }
      }
    }, 200);
  }

  /* A.14 - the editor's side of a variant change. `data-variant-id` on .lor-eng is the
     ONE value that travels to Supabase as engravingVariantId, and Liquid writes it once,
     for product.selected_or_first_available_variant. A customer switching silver -> 14K
     gold therefore had the wrong variant on the workshop record. The bridge decides WHEN
     a variant changed (it is the only half that can see the theme); this is what the
     editor does about it.

     The rim: `border` is still the file-level constant it has always been. Per-variant
     plating is A.9 plus a metafield the owner has not set, and inventing a heuristic here
     would be guessing at the metal on a record the workshop cuts from. So the attribute is
     read if the product declares it and nothing changes if it does not - which means the
     day the metafield is filled in, this already works. */
  function applyVariant(id){
    var host = document.querySelector('.lor-eng');
    if(host && id){ host.setAttribute('data-variant-id', String(id)); }
    var m = host && host.getAttribute('data-engraving-metal');
    if(m === 'gold' || m === 'silver' || m === 'black'){ border = m; }
    sync();
  }

  function payload(){
    function sideData(k){
      var st=S[k];
      if(st.mode==='none') return { type:'none' };
      if(st.mode==='text') return { type:'text', engraving_text: clean(st.text)||null, engraving_font: st.font,
        engraving_icon: st.icon, engraving_icon_pos: st.icon ? (st.iconPos||'above') : null,
        engraving_scale: Number((st.scale||1).toFixed(2)),
        shape_public_url: '…/renders/'+k+'-'+shape+'.png  ← the finished engraving' };
      return { type:'image',
        original_public_url: st.art ? '…/uploads/'+(st.name||'photo.jpg') : null,
        shape_public_url: st.art ? '…/renders/'+k+'-'+shape+'.png  ← the finished engraving' : null,
        engraving_zoom: Number(st.zoom.toFixed(3)),
        engraving_x: Math.round(st.off.x), engraving_y: Math.round(st.off.y) };
    }
    return { product_name: productName(), engraving_shape: shape, frame_border: border,
             front: sideData('front'), back: sideData('back') };
  }

  function paintOutput(){
    /* B.4 - this is the prototype's "what the workshop receives" explainer, and it costs
       TWO 900x900 filtered renders plus two synchronous toDataURL encodes of 810,000 px
       each. sync() calls it, and pointermove called sync() - so it ran on every finger
       movement. Inside the theme the container it fills is `.lor-eng-internal`, shipped
       `hidden`, so the whole cost bought a picture nobody could see. */
    if(dragging) return;
    if(document.querySelector('.lor-eng')) return;
    ['front','back'].forEach(function(k){
      var st = S[k], host = document.getElementById(k==='front' ? 'gridFront' : 'gridBack');
      var render = renderEngraving(k);
      if(!render){ host.innerHTML = '<div class="out-empty">' + lorT('This side is left blank — nothing is engraved and nothing is stored.') + '</div>'; return; }
      var html = st.mode==='photo' && st.thumb
        ? '<figure><img src="'+st.thumb+'" alt=lorT("The photo as uploaded")><figcaption>What is stored today<br><b>the raw upload</b></figcaption></figure>'
        : '<figure><div class="out-empty" style="aspect-ratio:1;display:grid;place-items:center">No upload &mdash; typed on the piece</div><figcaption>&nbsp;</figcaption></figure>';
      html += '<figure><img src="'+render+'" alt="The engraving-ready render"><figcaption>What should be stored<br><b>the finished engraving</b></figcaption></figure>';
      host.innerHTML = html;
    });
    document.getElementById('outJson').textContent = JSON.stringify(payload(), null, 2);
  }

  /* --- real contrast measurement, not a guess --- */
  function analyse(img){
    var n=64, w=document.createElement('canvas'); w.width=n; w.height=n;
    var g=w.getContext('2d',{willReadFrequently:true}); g.drawImage(img,0,0,n,n);
    var d=g.getImageData(0,0,n,n).data, lum=[], sum=0;
    for(var i=0;i<d.length;i+=4){ var L=0.2126*d[i]+0.7152*d[i+1]+0.0722*d[i+2]; lum.push(L); sum+=L; }
    var mean=sum/lum.length, v=0;
    for(var j=0;j<lum.length;j++){ v+=(lum[j]-mean)*(lum[j]-mean); }
    var sd=Math.sqrt(v/lum.length);
    var sorted=lum.slice().sort(function(a,b){return a-b;});
    var spread=sorted[Math.floor(lum.length*0.95)]-sorted[Math.floor(lum.length*0.05)];
    return { spread:spread, ok:(sd>=42 && spread>=120) };
  }

  function summary(k){
    var st=S[k];
    if(st.mode==='photo') return st.art ? lorT('a photo') : lorT('photo — none uploaded yet');
    if(st.mode==='text'){
      var bits=[];
      if(clean(st.text)) bits.push('“'+clean(st.text)+'” · '+st.font);
      /* Was 'symbol: ' + name.split(' ')[0] - the first SEARCH keyword - so the double
         heart read 'symbol: two' and the angel wings read 'symbol: angel'. */
      if(st.icon){ bits.push(iconLabel(st.icon)); }
      return bits.length ? bits.join(' + ') : lorT('text — nothing typed yet');
    }
    return lorT('left blank');
  }

  /* ---------------- rendering the UI ---------------- */
  /* The stage cell is wide and short; a 440x560 canvas is limited by its height and
     leaves the width empty, which is why the piece looked small. Once a photo is
     measured, give the canvas the crop's own proportions so it fills the cell. The
     drawn-shape path uses fixed coordinates, so it keeps 440x560. */
  /* B.10 - what the canvas WILL measure once its photo resolves, per shape, so the box
     can be reserved before the photo exists. Derived from the same crops fitCanvasToPhoto
     uses, so for the five stock shapes the reserve and the measurement agree and the
     measured update below is a no-op. A product with its own marked PREVIEW photo can
     land elsewhere; the reserve only has to stop the 30-80px jump, not be exact. */
  /* coin, square and heart re-measured 2026-09-24 after the necklaces were framed on the pendant
     (canvas width/height on the six necklaces: square .671/.695 · coin .963/.964 · heart 1.084/1.137) */
  var FACE_AR = { coin:0.96, square:0.68, heart:1.1, rect:1.25, bar:1.25 };
  function reserveFaces(ar){
    var v = ar || FACE_AR[shape] || (440/560);
    document.querySelectorAll('.face .slot').forEach(function(f){
      f.style.setProperty('--face-ar', String(v)); });
  }

  function fitCanvasToPhoto(){
    var slot = null, k;
    for(k in photoCache){ if(photoCache[k].ready){ slot = photoCache[k]; break; } }
    var want_w = 440, want_h = 560;
    if(slot && slot.cfg.crop){
      var ar = (slot.cfg.crop.sw * slot.img.width) / (slot.cfg.crop.sh * slot.img.height);
      want_h = 560;
      want_w = Math.round(Math.min(700, Math.max(360, 560 * ar)));
    }
    [document.getElementById('stage'), document.getElementById('stageBack'), document.getElementById('edCanvas'), document.getElementById('edCanvasBack')].forEach(function(c){
      if(c && (c.width !== want_w || c.height !== want_h)){ c.width = want_w; c.height = want_h; }
    });
    /* Once measured, the reserve follows the measurement rather than the table - and it
       is applied while the canvas is still hidden by `.swap`, so the box settles behind
       the fade instead of in front of her. Before that, the TABLE is the reserve:
       passing 440/560 here would have reserved the pre-photo box and reinstated the
       whole jump, which is exactly what it did on the first run of this. */
    reserveFaces(slot && slot.cfg.crop ? (want_w / want_h) : null);
  }

  /* The photo arrives a beat after the drawn plate. Hide the faces for the frame in
     which the swap happens, repaint, then fade them back. */
  function swapFaces(after){
    var cs = [].slice.call(document.querySelectorAll('.face canvas, .ed-faces canvas'));
    if(!cs.length){ after(); return; }
    cs.forEach(function(c){ c.classList.add('swap'); });
    requestAnimationFrame(function(){
      after();
      requestAnimationFrame(function(){
        cs.forEach(function(c){ c.classList.remove('swap'); });
      });
    });
  }

  function sync(){
    fitCanvasToPhoto();
    var st = cur();

    document.querySelectorAll('.tabs button').forEach(function(b){
      b.setAttribute('aria-selected', String(b.dataset.side===side));
    });
    /* These two lines used to feed #dotFront / #dotBack, recomputed on every keystroke
       inside .tabs - which applyProductRules sets to display:none. The computation was
       right and simply had nowhere to land. It lands here now. */
    if(SIDES === 2){
      var cf = document.getElementById('capFront'), cb = document.getElementById('capBack');
      if(cf) cf.textContent = capShow('front'); if(cb) cb.textContent = capShow('back');
      var ff = document.getElementById('faceFront'), fb = document.getElementById('faceBack');
      if(ff){ ff.classList.toggle('on', side==='front'); ff.classList.toggle('has', S.front.mode!=='none'); }
      if(fb){ fb.classList.toggle('on', side==='back');  fb.classList.toggle('has', S.back.mode !=='none'); }
    }
    /* The field, the counter and every warning addressed cur() and none of them said
       whose face that was - so switching read as the editor losing her words. */
    var lbl = document.querySelector('#paneText .lbl');
    if(lbl){
      lbl.textContent = lorT('YOUR ENGRAVING') + (SIDES === 2 ? ' · ' + lorT(side === 'front' ? lorT('FRONT') : lorT('BACK')) : '');
    }

    /* PHYSICAL LIMIT: a photo burns into one face only, never both */
    var otherHasPhoto = S[other()].mode==='photo' && !!S[other()].art;
    document.querySelectorAll('.seg button[data-mode]').forEach(function(b){
      b.setAttribute('aria-pressed', String(b.dataset.mode===st.mode));
      if(b.dataset.mode==='photo') b.disabled = otherHasPhoto;
    });
    var bl = document.getElementById('blocked');
    if(otherHasPhoto && st.mode!=='photo'){
      bl.classList.remove('hidden');
      document.getElementById('blockedWhy').textContent =
        lorTf('Your photo is already on the {side}', { side: lorT(other()) }) + '. '
            + lorT('A photo can be engraved into one face only — the piece cannot be held and burned twice. Choose Text for this side, or move the photo over.');
      document.getElementById('movePhoto').textContent = lorTf('Move the photo to the {side}', { side: lorT(side) });
    } else { bl.classList.add('hidden'); }

    document.getElementById('paneText').classList.toggle('hidden', st.mode!=='text');
    var pp = document.getElementById('panePhoto');
    pp.classList.toggle('hidden', st.mode!=='photo');
    pp.style.display = st.mode==='photo' ? 'flex' : '';
    document.getElementById('paneNone').classList.toggle('hidden', st.mode!=='none');
    document.getElementById('edStage').classList.toggle('photo', st.mode==='photo' && !!st.art);

    var etEl = document.getElementById('engText');
    if(document.activeElement !== etEl && etEl.value !== st.text) etEl.value = st.text;
    var cost = inlineCost(st);
    var inlineNow = ['beside','before','after'].indexOf(st.iconPos || 'above') > -1 || st._forcedInline;
    var counterHTML = lorTf(MAXLEN===1 ? lorT('{n} / {max} character') : lorT('{n} / {max} characters'),
            { n: '<b>'+st.text.length+'</b>', max: MAXLEN });
        if(cost && inlineNow){
          counterHTML += lorTf(' · the symbol takes about {n} more', { n: '<b>'+cost.chars+'</b>' });
        }
        document.getElementById('counter').innerHTML = counterHTML;

    /* Amber only once the cost is real. Below 70% of the Above size the name is
       visibly smaller on the metal, and that is the moment she deserves a number
       rather than a surprise. */
    var pc = document.getElementById('posCost');
    if(pc){
      if(cost && cost.ratio < 0.70){
        pc.classList.remove('hidden');
        pc.textContent = lorTf('Beside the text, {text} is engraved about {pct}% smaller. Above or Below keeps it full size.',
              { text: clean(st.text), pct: cost.pct });
      } else { pc.classList.add('hidden'); pc.textContent=''; }
    }
    /* The chip follows the state, not the drawer - so closing SYMBOLS no longer hides
       the fact that a symbol is attached. */
    var chip = document.getElementById('symChip');
    if(chip){
      var cIc = iconById(st.icon);
      if(st.mode === 'text' && cIc){
        chip.classList.remove('hidden');
        document.getElementById('symChipIc').innerHTML = iconSvg(cIc);
        document.getElementById('symChipTx').textContent = cIc.label;
      } else {
        chip.classList.add('hidden');
        document.getElementById('symChipIc').textContent = '';
        document.getElementById('symChipTx').textContent = '';
      }
    }

    /* the sentence names the gold line, so it shows exactly where the line is drawn.
       That is text now, not photo -- see the boundary block in paint(). */
    var cn = document.getElementById('cutNote');
    if(cn) cn.classList.toggle('hidden', st.mode !== 'text');

    var fw = document.getElementById('fontWarn');
    var hit = missingIn(st, false);
    if(hit){
      fw.classList.remove('hidden');
      fw.textContent = lorTf(hit.length === 1
            ? lorT('⚠ {font} cannot engrave {chars} — that character is not in this font. Pick another font, or use a symbol from SYMBOLS.')
            : lorT('⚠ {font} cannot engrave {chars} — those characters are not in this font. Pick another font, or use a symbol from SYMBOLS.'),
            { font: st.font, chars: hit.split('').join(' ') });
    } else { fw.classList.add('hidden'); }

    /* CONFIRM stops being a way past the warning. It is never disabled - a dead button
       explains nothing - it says what is wrong and, when pressed, takes her to the fonts. */
    var okBtn = document.getElementById('edOk');
    if(okBtn){
      var held = blockedReason();
      var n = held ? missingIn(S[held], true).length : 0;
      okBtn.classList.toggle('held', !!held);
      okBtn.textContent = held ? lorTf(n === 1 ? lorT('CONFIRM — {n} letter needs another font') : lorT('CONFIRM — {n} letters need another font'), { n: n })
             : lorT('CONFIRM ENGRAVING');
    }

    document.getElementById('fileRow').classList.toggle('hidden', !st.art);
    document.getElementById('zoomRow').classList.toggle('hidden', !st.art);
    document.getElementById('drop').classList.toggle('hidden', !!st.art);
    if(st.art){
      document.getElementById('thumb').src = st.thumb;
      document.getElementById('fileName').textContent = st.name;
      document.getElementById('zoom').value = Math.round(st.zoom*100);
      paintRange(document.getElementById('zoom'));
    }
    var v = document.getElementById('verdict');
    v.classList.remove('warn','ok');
    if(st.mode!=='photo' || !st.verdict){ v.classList.add('hidden'); }
    else {
      v.classList.remove('hidden');
      /* A.11 - size is prepended so she gets ONE combined answer, not two verdicts
         that could disagree. And below 400px on the short edge there is no green tick
         whatever the contrast says: the file simply cannot carry engravable detail. */
      var size = '';
      if(st.verdict.tiny){
        size = '<b>' + lorTf('⚠ This photo is too small to engrave well — {w} × {h}', { w: st.verdict.w, h: st.verdict.h }) + '</b>'
             + lorT('Eyes, hair and fine lines will come out as smudges. Send the original from your camera roll rather than one forwarded through a messaging app.') + '<br><br>';
      } else if(st.verdict.small){
        size = '<b>' + lorTf('This photo is small — {w} × {h}', { w: st.verdict.w, h: st.verdict.h }) + '</b>'
             + lorT('Engraved at this size, fine detail such as eyes and hair will blur. A photo from your camera roll rather than a messaging app comes out much sharper.') + '<br><br>';
      }
      /* ⚠️ The spec contradicts itself here: its prose gates the green tick on
         `!tiny`, while its own verify line requires 640x480 - small but not tiny - to
         render `warn`. Followed the verify line, because the block carries ONE colour
         and this one would have been green while its first sentence read "fine detail
         such as eyes and hair will blur". Green with a warning inside it is worse than
         amber: it tells her two things at once and she believes the colour. */
      var good = st.verdict.ok && !st.verdict.tiny && !st.verdict.small;
      if(good){ v.classList.add('ok');
        v.innerHTML = size + '<b>' + lorT('✓ Good contrast — this will engrave cleanly') + '</b>' + lorT('Clear light and dark areas. The preview is close to the finished piece.'); }
      else if(st.verdict.ok){ v.classList.add('warn');
        v.innerHTML = size + '<b>' + lorT('Contrast is fine') + '</b>' + lorT('The light and dark are there — it is the number of pixels that limits this one.'); }
      else { v.classList.add('warn');
        v.innerHTML = size + '<b>' + lorT('⚠ Low contrast — fine detail will be lost') + '</b>' + lorT('The laser burns <b>one tone</b> into silver, not colour. A dark subject on a dark background comes out as one flat shape.'); }
    }

    var sv = Math.round((st.scale||1)*100);
    document.getElementById('sizeRange').value = sv;
    paintRange(document.getElementById('sizeRange'));
    /* A slider with no readout is a control you can only judge by its effect - and its
       effect on the name was the opposite of its direction. */
    var svEl = document.getElementById('sizeVal'); if(svEl) svEl.textContent = sv;
    var snEl = document.getElementById('sizeNote');
    if(snEl){
      /* Once the cap has taken over, "larger type engraves less crisply" is worse than
         useless: it implies the slider still does something, while the drawn letters have
         stopped growing. Say the true thing instead. Kept to when she is actually pushing
         past the default (sv > 100), so it never nags at the resting size. */
      var sizeCapped = !!(LOR_FIT && LOR_FIT.capped && LOR_FIT.got < LOR_FIT.wanted && sv > 100);
      snEl.textContent = sizeCapped
        ? lorT('Larger text no longer fits on this piece.')
        : lorT(sv >= 130 ? lorT('Larger type engraves less crisply on a face this size.')
                         : lorT('Small text engraves more crisply than large text on a face this size.'));
      snEl.classList.toggle('capped', sizeCapped);
    }
    /* 'beside' is the old name for 'before'; without this a restored state would
       light up no button at all and look as though nothing were chosen. */
    /* On a BAR the symbol may only sit beside the words -- never above or below them.
       Owner, 2026-09-21: "symbols can be to the right or left, cannot be above or bellow
       for technical reason". It is a workshop limit, not a preference: the engravable
       face on these pieces is about 1:4 to 1:6 (measured 0.35 x 0.10 of the photo on the
       bracelet, 0.42 x 0.064 on the cuff), so stacking two rows halves the height of each
       and the mark stops being readable on silver.

       The editor already had _forcedInline, which quietly moved the symbol to the side
       AFTER she chose Above and then explained itself. That is a repair, not a rule:
       offering a choice and then overriding it reads as a fault. So the two impossible
       buttons are removed from the row on these pieces, and the default moves to Right. */
    /* Above and Below need a face deep enough for two rows. The test used to be
       shape === 'bar', which was too narrow: the heart and rectangle RINGS are not bars,
       yet their plate holds one character, and they went on offering a stack that could
       never be read on silver.

       Owner, 2026-09-22: "for symbols position its allowed only when the item can engrave
       images", then "the 4 position". That is the right test and not a coincidence -
       a piece takes a photograph BECAUSE it has a wide flat face, and that same face is
       what holds two rows. Where no photo is offered the face is shallow or tiny.

       PHOTO_OK comes from data-engraving-photo on the editor's host, and is true in the
       standalone prototype so every case stays testable there. */
    var stack = PHOTO_OK;
    if(!stack && ['above','below'].indexOf(st.iconPos || 'above') > -1) st.iconPos = 'after';
    var activePos = st.iconPos === 'beside' ? 'before' : (st.iconPos || (stack ? 'above' : 'after'));
    document.querySelectorAll('#trayPos button[data-pos]').forEach(function(b){
      var impossible = !stack && (b.dataset.pos === 'above' || b.dataset.pos === 'below');
      b.hidden = impossible;
      b.setAttribute('aria-pressed', String(!impossible && b.dataset.pos === activePos));
    });
    /* A.6 - when the face is too shallow for two rows the editor moves the symbol
       inline by itself. Saying so is the difference between "the control is broken"
       and "this piece cannot do that". */
    document.getElementById('posNote').textContent =
      lorT((st.icon && st.text && st._forcedInline)
        ? lorT('This face is too shallow for a symbol above the words — it has been placed before them.')
        : st.icon && st.text
          ? lorT('Where the symbol sits against your text.')
          : lorT('Pick a symbol and type some text — then this decides where the symbol sits.'));
    document.getElementById('clearSym').classList.toggle('hidden', !st.icon);
    document.querySelectorAll('#trayIcons button[data-icon]').forEach(function(b){
      b.setAttribute('aria-pressed', String(b.dataset.icon === st.icon));
    });
    document.querySelectorAll('#fontList button').forEach(function(b){
      b.setAttribute('aria-pressed', String(b.dataset.font === st.font));
    });
    document.querySelectorAll('.tools button').forEach(function(b){
      b.setAttribute('aria-pressed', String(b.dataset.tray === tray));
      if(b.dataset.tray==='pos') b.disabled = !(st.icon && st.text);
      if(b.dataset.tray==='fonts') b.disabled = (st.mode !== 'text');
      /* B.5 - SYMBOLS and SIZE no longer require Text mode. The icon click handler
         below already contains `if(st.mode!=='text') st.mode='text'` - a line written
         for exactly this case that could never run, because the only button that
         reaches it was disabled in precisely the state it was written for. A small
         symbol on its own IS a complete engraving. Only a photo side excludes them. */
      if(b.dataset.tray==='icons') b.disabled = (st.mode === 'photo');
      if(b.dataset.tray==='size')  b.disabled = (st.mode === 'photo');
    });

    document.getElementById('edHint').textContent = lorT(
          st.mode==='photo' ? (st.art ? lorT('Drag the photo to reposition it') : lorT('Upload a photo to see it on the piece'))
        : '');   /* text and none: no line - the field and the piece say it already (owner, 2026-09-24) */

    document.getElementById('cardFront').textContent = summary('front');
    document.getElementById('cardBack').textContent  = summary('back');
    document.querySelectorAll('.sidecard').forEach(function(c){
      var k = c.dataset.openside, s = S[k];
      c.classList.toggle('warn', (s.mode==='photo' && !s.art) || (s.mode==='text' && !s.text && !s.icon));
    });
    document.getElementById('tapnote').textContent = lorT((S.front.mode==='none' && S.back.mode==='none')
          ? lorT('Tap the piece to start engraving') : lorT('Tap the piece to change your engraving'));
    document.getElementById('qtyNote').textContent = (S.front.mode==='none' && S.back.mode==='none')
          ? '' : lorT('All pieces get the same engraving');

    if(sctxBack){
      var keep = side;
      side = 'front'; paint(sctx, false);
      side = 'back';  paint(sctxBack, false);
      side = keep;
    } else {
      paint(sctx, false);
    }
    if(ed.open){
      if(SIDES === 2 && ectxB){
        /* Same trick the page preview uses: borrow `side` for one paint each, then
           put it back. The caret belongs only on the face being edited. */
        var keep = side;
        side = 'front'; paint(ectx,  keep === 'front');
        side = 'back';  paint(ectxB, keep === 'back');
        side = keep;
        edC.classList.toggle('on',  side === 'front');
        edCB.classList.toggle('on', side === 'back');
      } else {
        paint(ectx, true);
      }
    }
    paintOutput();
  }

  /* ---------------- typing straight onto the metal ---------------- */
  function focusGhost(){
    var st = cur();
    ghost.value = st.text;
    typing = true; caretOn = true;
    ghost.focus();
    try { ghost.setSelectionRange(ghost.value.length, ghost.value.length); } catch(_) {}
    sync();
  }
  /* 03/11, order #1037: "Kirsitubakas 🍒" reached the workshop. No engraving font has an
     emoji, so the font guard only WARNED and she bought anyway. An emoji is taken out as it
     is typed and she is pointed to SYMBOLS. Astral characters (every emoji), the BMP
     symbol/dingbat blocks, variation selectors, ZWJ and keycap marks - no Baltic letter. */
  var EMOJI_RE = /[\uD800-\uDFFF\u2600-\u27BF\u2B00-\u2BFF\uFE0E\uFE0F\u200D\u20E3]/g;
  var emojiCut = false;
  function noEmoji(v){
    v = String(v == null ? '' : v);
    var clean = v.replace(EMOJI_RE, '');
    if(clean !== v){ emojiCut = true; v = clean.replace(/ {2,}/g, ' '); }
    return v;
  }
  function sayEmoji(){
    var msg = lorT('Emoji cannot be engraved — use a symbol from SYMBOLS instead.');
    var n = document.getElementById('edSay');
    if(emojiCut) say(msg); else if(n && n.textContent === msg) say('');
  }
  ghost.addEventListener('input', function(){
    emojiCut = false;
    cur().text = noEmoji(this.value).slice(0, MAXLEN);
    if(this.value !== cur().text) this.value = cur().text;
    caretOn = true; sync();
    sayEmoji();
  });
  ghost.addEventListener('blur',  function(){ typing = false; sync(); });
  ghost.addEventListener('focus', function(){ typing = true; sync(); });

  /* the visible field writes to the same state the metal does */
  var engText = document.getElementById('engText');
  /* the two inputs must never disagree with MAXLEN */
  ghost.maxLength = MAXLEN;
  engText.maxLength = MAXLEN;
  engText.addEventListener('input', function(){
    emojiCut = false;
    cur().text = noEmoji(this.value).slice(0, MAXLEN);
    if(this.value !== cur().text) this.value = cur().text;
    ghost.value = cur().text;
    caretOn = true; sync();
    sayEmoji();
  });
  /* A tick late on purpose: the phone keyboard resizes the viewport AFTER focus fires,
     so scrolling immediately would aim at the old layout. 'nearest' moves the minimum. */
  engText.addEventListener('focus', function(){
    typing = true; caretOn = true;
    var self = this;
    setTimeout(function(){
      try { self.scrollIntoView({ block:'nearest' }); } catch(e){ self.scrollIntoView(); }
    }, 80);
    sync();
  });
  engText.addEventListener('blur',  function(){ typing = false; sync(); });
  setInterval(function(){ if(!typing || !ed.open) return; caretOn = !caretOn; paint(live(), true); }, 520);

  function setMode(m){
    var st = cur();
    st.mode = m;
    if(m !== 'text'){ ghost.blur(); document.getElementById('engText').blur(); typing = false; if(tray && tray !== 'pos') setTray(null); }
    sync();
    if(m === 'text') focusGhost();
  }
  document.querySelectorAll('.seg button[data-mode]').forEach(function(b){
    b.addEventListener('click', function(){ setMode(b.dataset.mode); });
  });

  /* tapping the piece is how engraving starts - exactly like the reference */
  /* One tap does the natural thing: if the face tapped is not the one being edited it
     becomes so AND the tap still lands, instead of costing the customer a second tap. */
  /* A tap on the OTHER face selects it and stops there. It used to select and act in
     the same gesture, which meant a tap intended only to switch also began dragging
     the photo on the face she had just arrived at - her framing moved because she
     looked away. If the newly selected face is already in text mode the keyboard is
     brought up for her, so the common case still costs one tap. */
  function faceTap(which, e){
    if(SIDES === 2 && side !== which){
      switchTo(which, function(){ if(cur().mode === 'text') focusGhost(); });
      return;
    }
    var st = cur();
    if(st.mode==='photo' && st.art){ startDrag(e, which === 'back' ? edCB : edC); return; }
    if(st.mode!=='text'){ setMode('text'); return; }
    sync(); focusGhost();
  }
  edC.addEventListener('pointerdown', function(e){ faceTap('front', e); });
  if(edCB) edCB.addEventListener('pointerdown', function(e){ faceTap('back', e); });
  /* A keyboard could reach neither face: the canvases were not focusable and the tab
     row that would have switched them is display:none. They are buttons now. */
  [[edC,'front'],[edCB,'back']].forEach(function(p){
    if(!p[0]) return;
    p[0].addEventListener('keydown', function(e){
      if(e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      if(SIDES === 2 && side !== p[1]){ switchTo(p[1], function(){ if(cur().mode==='text') focusGhost(); }); return; }
      if(cur().mode !== 'text'){ setMode('text'); return; }
      focusGhost();
    });
  });
  document.querySelectorAll('.faces .face').forEach(function(b){
    b.addEventListener('click', function(){ openEd(b.dataset.openside); });
  });
  /* The biggest, most-pressed control in the block used to open 'front' as a literal,
     so a customer who had just worked on the back and closed the editor was put back
     on the front and had to find her way across again. */
  var lastSide = 'front';
  document.getElementById('openEd').addEventListener('click', function(){ openEd(lastSide); });
  document.querySelectorAll('.sidecard').forEach(function(c){
    c.addEventListener('click', function(){ openEd(c.dataset.openside); });
  });

  /* ---------------- the editor ---------------- */
  var invited = false;
  function openEd(which){
    side = which || 'front';
    snapshot = JSON.stringify({ front:strip(S.front), back:strip(S.back) });
    if(ed.showModal) ed.showModal(); else ed.setAttribute('open','');
    setTray(null);
    sync();
    say('');
    /* Once per page: the resting face tips toward the light so she learns it is hers
       to touch. Never repeated - an invitation that keeps arriving is a nag. */
    if(SIDES === 2 && !invited){
      invited = true;
      var rest = document.getElementById(side === 'front' ? 'faceBack' : 'faceFront');
      if(rest){ rest.classList.remove('invite'); void rest.offsetWidth; rest.classList.add('invite'); }
    }
    if(cur().mode === 'text') focusGhost();
  }
  function strip(s){ return { mode:s.mode, zoom:s.zoom, off:{x:s.off.x,y:s.off.y}, text:s.text, font:s.font,
                              icon:s.icon, iconPos:s.iconPos, scale:s.scale, name:s.name }; }
  function closeEd(){ lastSide = side; ghost.blur(); typing=false; say('');
                      if(ed.close) ed.close(); else ed.removeAttribute('open'); sync(); }
  function revert(){
    if(snapshot){
      var snap = JSON.parse(snapshot);
      ['front','back'].forEach(function(k){
        var s = S[k], o = snap[k];
        s.mode=o.mode; s.zoom=o.zoom; s.off={x:o.off.x,y:o.off.y}; s.text=o.text; s.font=o.font;
        s.icon=o.icon; s.iconPos=o.iconPos; s.scale=o.scale; s.name=o.name;
        if(o.mode!=='photo'){ /* the image object itself is kept; only the mode decides if it is used */ }
      });
    }
    closeEd();
  }
  /* Only the right-hand column scrolls, and it is the narrower half of a wide dialog.
     A wheel turn with the pointer over the picture - or over the header, the tabs or
     the footer - did nothing at all, and the modal blocks the page behind it, so it
     read as "I cannot scroll to confirm". Forward any wheel inside the dialog to the
     column that actually scrolls, unless the pointer is already over something
     scrollable of its own (the symbol list, for instance). */
  (function(){
    function scrollableUnder(node){
      while(node && node !== ed){
        if(node.scrollHeight > node.clientHeight + 1){
          var oy = getComputedStyle(node).overflowY;
          if(oy === 'auto' || oy === 'scroll') return node;
        }
        node = node.parentNode;
      }
      return null;
    }
    ed.addEventListener('wheel', function(e){
      var col = document.querySelector('.ed-side');
      if(!col || getComputedStyle(col).display === 'contents') return;   /* phone sheet scrolls itself */
      if(col.scrollHeight <= col.clientHeight + 1) return;               /* nothing to scroll */
      if(scrollableUnder(e.target)) return;                             /* let that one have it */
      col.scrollTop += e.deltaY;
      e.preventDefault();
    }, { passive:false });
  })();

  /* Leaving the editor used to throw the work away in silence. Now it only asks when
     there is actually something to lose - opening the editor and changing nothing
     still closes on one press. */
  var edAsk = document.getElementById('edAsk');
  function dirty(){
    return !!snapshot && snapshot !== JSON.stringify({ front:strip(S.front), back:strip(S.back) });
  }
  function openAsk(){ if(edAsk.showModal) edAsk.showModal(); else edAsk.setAttribute('open',''); }
  function closeAsk(){ if(edAsk.close) edAsk.close(); else edAsk.removeAttribute('open'); }
  function askRevert(){ if(!dirty()){ closeEd(); return; } openAsk(); }

  document.getElementById('askKeep').addEventListener('click', closeAsk);
  document.getElementById('askDrop').addEventListener('click', function(){ closeAsk(); revert(); });
  edAsk.addEventListener('cancel', function(e){ e.preventDefault(); closeAsk(); });

  document.getElementById('edX').addEventListener('click', askRevert);
  document.getElementById('edCancel').addEventListener('click', askRevert);
  document.getElementById('edOk').addEventListener('click', function(){
    var held = blockedReason();
    if(!held){ closeEd(); return; }
    /* Take her to the fix rather than refusing her: the offending face, the font tray
       open, and the fonts that CAN cut those letters marked. */
    var bad = missingIn(S[held], true);
    function land(){
      openTray('fonts');
      markFittingFonts(bad);
      say(lorTf('{font} cannot cut {chars}. Pick a font below that can.',
            { font: S[held].font, chars: bad.split('').join(' or ') }));
      var fl = document.getElementById('fontList');
      if(fl && fl.scrollIntoView) fl.scrollIntoView({block:'nearest'});
    }
    if(SIDES === 2 && side !== held){ switchTo(held, land); } else { land(); }
  });

  /* A green ring and the word "fits" on every font that carries the blocked letters,
     so the answer is visible rather than a matter of trying each of the sixteen. */
  function markFittingFonts(bad){
    document.querySelectorAll('#fontList .chip').forEach(function(chip){
      var b = chip.querySelector('button'), f = b && b.dataset.font;
      if(!f) return;
      var gap = FONT_GAPS[f] || '', ok = true;
      for(var i=0;i<bad.length;i++){ if(gap.indexOf(bad.charAt(i)) > -1){ ok = false; break; } }
      chip.classList.toggle('fits', ok && !!bad);
    });
  }
  ed.addEventListener('cancel', function(e){ e.preventDefault(); askRevert(); });

  document.querySelectorAll('.tabs button').forEach(function(b){
    b.addEventListener('click', function(){
      ghost.blur(); typing=false;
      side = b.dataset.side; setTray(null); sync();
      if(cur().mode==='text') focusGhost();
    });
  });

  /* setTray TOGGLES - it is wired to the toolbar, where pressing FONTS twice should
     close it. Anything that means "make sure this tray is showing" must say so, or it
     closes the very tray it was sent to open. */
  function openTray(name){ if(tray !== name) setTray(name); }
  function setTray(name){
    tray = (tray === name) ? null : name;
    document.getElementById('tray').classList.toggle('hidden', !tray);
    ['fonts','icons','size','pos'].forEach(function(t){
      document.getElementById('tray'+t.charAt(0).toUpperCase()+t.slice(1)).classList.toggle('hidden', tray !== t);
    });
    sync();
  }
  document.querySelectorAll('.tools button').forEach(function(b){
    b.addEventListener('click', function(){ setTray(b.dataset.tray); });
  });

  /* ---------------- fonts and symbols ---------------- */
  function buildFonts(){
    document.getElementById('fontList').innerHTML = FONTS.map(function(f){
      var bad = !!FONT_GAPS[f];
      return '<div class="chip"><button type="button" data-font="'+f+'" aria-pressed="false" aria-label="'+f+'" '+
        'style="font-family:'+f+', Georgia, serif">Aa</button>'+
        '<span class="fname">'+f+(bad ? '<span class="flag">'+lorT('no ąčę')+'</span>' : '')+'</span></div>';
    }).join('');
    document.querySelectorAll('#fontList button').forEach(function(b){
      b.addEventListener('click', function(){
        cur().font = b.dataset.font; sync();
        /* the "fits" marks answered one specific question; once it is answered they
           would be a stale recommendation sitting on the tray */
        if(!blockedReason()){ markFittingFonts(''); say(''); }
      });
    });
  }
  function buildIcons(q){
    var host = document.getElementById('iconCats'), jump = document.getElementById('jump');
    q = (q||'').trim().toLowerCase();
    if(jump.children.length === 1){
      LIB.forEach(function(c2){
        var b=document.createElement('button'); b.type='button'; b.textContent=lorT(c2.cat);
        b.addEventListener('click', function(){
          var el=document.getElementById('cat-'+c2.cat.replace(/[^A-Za-z]/g,''));
          if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
        });
        jump.appendChild(b);
      });
    }
    var terms = q ? q.toLowerCase().split(/\s+/).filter(Boolean).map(function(w){
      return (w.length > 3 && w.charAt(w.length-1) === 's') ? w.slice(0, -1) : w; }) : [];
    var html='', found=0;
    LIB.forEach(function(c2){
      /* B.6 - one contiguous indexOf over `id + name` meant "wedding ring" matched
         nothing, because the haystack reads "rings rings wedding marriage": the words
         are there, the phrase is not. Measured before the fix: wedding ring · wedding
         rings · christmas tree · love heart · flowers · lucky · four leaf ALL returned
         zero. Now every word must appear somewhere, in any order, and a trailing s on
         a word longer than three letters is optional. */
      var items = terms.length ? c2.items.filter(function(i){
        /* The translated label joins the haystack so a Lithuanian customer who types
           "sirdis" finds the heart. The English keywords stay - they cost nothing
           and a customer may still type them. */
        var hay = (i.id + ' ' + i.name + ' ' + i.label + ' ' + lorT(i.label)).toLowerCase();
        return terms.every(function(w){ return hay.indexOf(w) > -1; });
      }) : c2.items;
      if(!items.length) return;
      found += items.length;
      html += '<div class="cat" id="cat-'+c2.cat.replace(/[^A-Za-z]/g,'')+'"><h3>'+lorT(c2.cat)+'</h3><div class="grid">'+
        items.map(function(i){
          /* title/aria-label carried `name`, the search string, so a screen reader read
             "two hearts love couple" and a tooltip showed the keywords. The human label
             belongs here; `name` stays for matching only. */
          /* The name under the tile is the whole point of C.3 reaching the tray: a
             customer scanning 41 outlines cannot tell a clover from a four-leaf
             anything, and hover does not exist on a phone. */
          var lbl = lorT(i.label);
          return '<div class="isym"><button type="button" data-icon="'+i.id+
                 '" aria-pressed="false" title="'+lbl+'" aria-label="'+lbl+'">'+
                 iconSvg(i)+'</button><span class="iname">'+lbl+'</span></div>';
        }).join('')+'</div></div>';
    });
    host.innerHTML = found ? html :
      '<p class="nores">' + lorTf('No symbol matches “{q}”.', { q: q }) + '<br>' +
      '<button type="button" class="showall" id="showAll">' +
      lorTf('Show all {n} symbols', { n: ALL_ICONS.length }) + '</button></p>';
    var sa = document.getElementById('showAll');
    if(sa) sa.addEventListener('click', function(){
      var f=document.getElementById('iconSearch'); if(f) f.value='';
      buildIcons(''); sync();
      /* Clearing the field here does not fire its `input` listener, so the row that
         the listener hid stays hidden - the full library is back and its jump links
         are not. Measured: jumpBack === false before this line. */
      var j=document.getElementById('jump'); if(j) j.classList.remove('hidden');
      if(f) f.focus();
    });
    host.querySelectorAll('button[data-icon]').forEach(function(b){
      b.addEventListener('click', function(){
        var st=cur(); st.icon = (st.icon===b.dataset.icon) ? null : b.dataset.icon;
        if(st.mode!=='text') st.mode='text';
        sync();
      });
    });
  }
  /* The search box was removed from the tray (owner, 2026-09-24); the listener stays
     guarded so the tray still works if the box ever comes back. */
  var iconSearchEl = document.getElementById('iconSearch');
  if(iconSearchEl) iconSearchEl.addEventListener('input', function(){
    buildIcons(this.value); sync();
    /* Its targets do not exist while a search is filtering, and the `if(el)` guard
       swallows the miss - so the row looks alive and does nothing. */
    var j = document.getElementById('jump');
    if(j) j.classList.toggle('hidden', !!this.value.trim());
  });
  document.getElementById('clearSym').addEventListener('click', function(){ cur().icon=null; sync(); });
  /* Same one action as the tray's Clear, reachable without opening the tray. */
  document.getElementById('symChipX').addEventListener('click', function(){
    var was = iconLabel(cur().icon);
    cur().icon = null; sync();
    if (was) { say(was + ' removed.', true); }
  });
  document.querySelectorAll('#trayPos button[data-pos]').forEach(function(b){
    b.addEventListener('click', function(){ cur().iconPos = b.dataset.pos; sync(); });
  });
  /* The sliders are drawn, not native (owner, 2026-09-24: "Make the size slider button
     smaller too" - a native thumb cannot be resized). The green fill up to the value is
     a custom property, so it follows every change: dragging, and values set by sync(). */
  function paintRange(el){
    if(!el) return;
    var lo = +el.min || 0, hi = +el.max || 100, v = +el.value;
    el.style.setProperty('--p', ((v - lo) / ((hi - lo) || 1) * 100) + '%');
  }
  document.querySelectorAll('.slider input[type=range]').forEach(function(r){
    paintRange(r);
    r.addEventListener('input', function(){ paintRange(r); });
  });
  document.getElementById('sizeRange').addEventListener('input', function(){ cur().scale = this.value/100; sync(); });
  document.getElementById('clearText').addEventListener('click', function(){
    cur().text=''; ghost.value=''; sync(); focusGhost();
  });

  /* ---------------- the photo side ---------------- */
  var fileInput=document.getElementById('file'), drop=document.getElementById('drop');
  ['dragenter','dragover'].forEach(function(e){ drop.addEventListener(e,function(ev){ev.preventDefault();drop.classList.add('over');}); });
  ['dragleave','drop'].forEach(function(e){ drop.addEventListener(e,function(ev){ev.preventDefault();drop.classList.remove('over');}); });
  drop.addEventListener('drop', function(ev){ if(ev.dataTransfer.files[0]) load(ev.dataTransfer.files[0]); });
  fileInput.addEventListener('change', function(){ if(this.files[0]) load(this.files[0]); });
  /* Every way this could fail used to be silent. The MIME gate and the 5 MB gate were
     the only two rejections; after them a bare `return`, no FileReader.onerror and no
     Image.onerror meant a HEIC from an iPhone, a corrupt file or a decode failure
     produced nothing at all - no photo, no message, no hint. Worse, fileInput.value was
     cleared only inside img.onload, so the SAME file chosen a second time fired no
     change event and the editor stayed dead for the rest of the visit.
     Now: the input is cleared first on every path, every failure has a sentence, and a
     large photo is resized instead of refused. */
  var MAX_EDGE = 1600, HARD_BYTES = 25 * 1024 * 1024;

  function esc(s){ var d = document.createElement('span'); d.textContent = String(s); return d.innerHTML; }
  function clearFileErr(){ var n = document.getElementById('fileErr'); if(n){ n.classList.add('hidden'); n.innerHTML=''; } }
  function fileErr(title, body){
    var n = document.getElementById('fileErr');
    if(!n){ return; }
    n.innerHTML = '<b>⚠ ' + title + '</b>' + body;
    n.classList.remove('hidden');
  }
  function busy(on){
    var lead = document.getElementById('dropLead');
    if(lead){ lead.textContent = lorT(on ? lorT('Preparing your photo…') : lorT('Tap to upload your photo')); }
    drop.classList.toggle('busy', !!on);
  }

  function load(f){
    fileInput.value = '';                 /* FIRST, on every path - see the note above */
    clearFileErr();
    if(!f) return;
    var nm = f.name || lorT('that file');
    if(!/^image\//.test(f.type) && !/\.(jpe?g|png|webp|heic|heif|avif|tiff?)$/i.test(nm)){
      fileErr(lorT('That is not a photo'), lorTf('{name} is not an image. Choose a JPG, PNG or WEBP.', { name: esc(nm) }));
      return;
    }
    if(f.size > HARD_BYTES){
      fileErr(lorT('That photo is very large'),
              lorTf('{name} is {mb} MB. Choose a photo under 25 MB.', { name: esc(nm), mb: Math.round(f.size/1048576) }));
      return;
    }
    busy(true);
    var fr = new FileReader();
    fr.onerror = function(){
      busy(false);
      fileErr(lorT('We could not read that file'),
              lorTf('{name} could not be read from your device. Try choosing it again.', { name: esc(nm) }));
    };
    fr.onload = function(){
      var img = new Image();
      img.onerror = function(){
        busy(false);
        fileErr(lorT('We could not open that file'),
          lorTf('{name} — your phone may have saved it in a format the browser cannot read. Open it in your photo app, save or share it as JPEG, and try again.', { name: esc(nm) }));
      };
      img.onload = function(){
        busy(false);
        var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        var art = img, thumb = fr.result, k = Math.min(1, MAX_EDGE / Math.max(w, h));
        /* 1600px on the long edge is still nearly twice the 900px the workshop file is
           rendered at, so nothing the laser can cut is lost - and every later drawImage
           and the upload itself get cheaper. */
        if(k < 1){
          var oc = document.createElement('canvas');
          oc.width = Math.round(w*k); oc.height = Math.round(h*k);
          oc.getContext('2d').drawImage(img, 0, 0, oc.width, oc.height);
          art = oc; thumb = oc.toDataURL('image/jpeg', 0.9);
        }
        var st = cur();
        st.art = art; st.zoom = 1; st.off = {x:0,y:0}; st.thumb = thumb; st.name = f.name;
        st.verdict = analyse(img);
        /* A.11 - the contrast test never looked at how many pixels there are. A 300px
           thumbnail off a messaging app can pass contrast and still engrave as mush,
           because the laser resolves far finer than the file does. */
        st.verdict.w = img.naturalWidth || img.width;
        st.verdict.h = img.naturalHeight || img.height;
        st.verdict.small = Math.min(st.verdict.w, st.verdict.h) < 800;
        st.verdict.tiny  = Math.min(st.verdict.w, st.verdict.h) < 400;
        st.mode = 'photo';
        sync();
      };
      img.src = fr.result;
    };
    fr.readAsDataURL(f);
  }
  document.getElementById('removeBtn').addEventListener('click', function(){
    var st=cur(); st.art=null; st.verdict=null; st.thumb=''; st.name=''; fileInput.value=''; sync();
  });
  document.getElementById('movePhoto').addEventListener('click', function(){
    var from=S[other()], to=cur();
    to.art=from.art; to.zoom=from.zoom; to.off={x:from.off.x,y:from.off.y};
    to.thumb=from.thumb; to.name=from.name; to.verdict=from.verdict; to.mode='photo';
    from.art=null; from.verdict=null; from.thumb=''; from.name='';
    from.mode = from.text ? 'text' : 'none';
    sync();
  });
  var zoomEl = document.getElementById('zoom');
  zoomEl.addEventListener('input', function(){
    cur().zoom=this.value/100; sync(); remeasure();   /* A.12 - zoom changes what is framed */
  });
  function nudgeZoom(step){
    var v = Math.max(+zoomEl.min, Math.min(+zoomEl.max, Math.round(cur().zoom*100) + step));
    cur().zoom = v/100;
    zoomEl.value = v;
    sync(); remeasure();
  }
  document.getElementById('zoomOut').addEventListener('click', function(){ nudgeZoom(-10); });
  document.getElementById('zoomIn').addEventListener('click', function(){ nudgeZoom(10); });

  /* The drag has to measure the canvas it actually started on. With two faces on
     screen, measuring edC while dragging the back one would put the photo somewhere
     else entirely, so the element travels with the gesture. */
  var dragging=false, last=null, dragEl=edC;
  var moveRaf = 0, pendingMove = null;
  function pt(e){ var r=dragEl.getBoundingClientRect(), k=dragEl.width/r.width;
                  return {x:(e.clientX-r.left)*k, y:(e.clientY-r.top)*k}; }
  function startDrag(e, el){ dragEl = el || edC; dragging=true; last=pt(e);
                             dragEl.setPointerCapture && dragEl.setPointerCapture(e.pointerId); }
  function live(){ return (SIDES === 2 && side === 'back' && ectxB) ? ectxB : ectx; }
  [edC, edCB].forEach(function(cv){
    if(!cv) return;
    /* One repaint per displayed frame, not one per event. There was no
       requestAnimationFrame anywhere in this file, so a 120 Hz surface could queue
       three full repaints per frame. And sync() is gone from this path entirely -
       it rebuilds counters, warnings and the explainer, none of which change while
       a thumb is moving; the existing pointerup already calls it. */
    cv.addEventListener('pointermove', function(e){
      if(!dragging) return;
      pendingMove = e; e.preventDefault();
      if(moveRaf) return;
      moveRaf = requestAnimationFrame(function(){
        moveRaf = 0;
        var p = pt(pendingMove), st = cur();
        st.off.x += (p.x-last.x); st.off.y += (p.y-last.y); last = p;
        paint(live(), true);
      });
    });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
      cv.addEventListener(ev, function(){
        if(!dragging) return;
        dragging = false;
        /* drop any frame still queued - it would paint from the last pointer position
           after the gesture is already over */
        if(moveRaf){ cancelAnimationFrame(moveRaf); moveRaf = 0; }
        pendingMove = null;
        sync();
        remeasure();   /* A.12 - panning changes what is framed */
      });
    });
  });

  /* A pinch on the piece itself. The slider needs room at the bottom of the panel and a
     phone has none to give - so the gesture everyone already expects of a photo is wired
     to the canvas, where there is nothing to run out of. Two fingers only: one finger is
     still the drag that frames the photo. */
  [edC, edCB].forEach(function(cv){
    if(!cv) return;
    var d0 = 0, z0 = 1;
    function gap(t){
      var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx*dx + dy*dy);
    }
    cv.addEventListener('touchstart', function(e){
      var st = cur();
      if(e.touches.length !== 2 || st.mode !== 'photo' || !st.art) return;
      e.preventDefault();
      dragging = false;                 /* a pinch must not also pan */
      if(moveRaf){ cancelAnimationFrame(moveRaf); moveRaf = 0; }
      d0 = gap(e.touches); z0 = st.zoom;
    }, { passive: false });
    cv.addEventListener('touchmove', function(e){
      var st = cur();
      if(!d0 || e.touches.length !== 2 || st.mode !== 'photo' || !st.art) return;
      e.preventDefault();
      var z = z0 * (gap(e.touches) / d0);
      st.zoom = Math.max(0.6, Math.min(2.2, z));
      if(zoomEl) zoomEl.value = Math.round(st.zoom*100);
      paint(live(), true);
    }, { passive: false });
    ['touchend','touchcancel'].forEach(function(ev){
      cv.addEventListener(ev, function(e){
        if(!d0 || e.touches.length) return;
        d0 = 0;
        sync(); remeasure();            /* A.12 - zoom changes what is framed */
      });
    });
  });

  /* ---------------- the product demo bar ---------------- */
  document.querySelectorAll('#shapes button[data-shape]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.stopPropagation();
      shape = b.dataset.shape;
      document.querySelectorAll('#shapes button[data-shape]').forEach(function(x){
        x.setAttribute('aria-pressed', String(x.dataset.shape===shape)); });
      S.front.off={x:0,y:0}; S.back.off={x:0,y:0};
      document.getElementById('title').textContent = productName();
      reserveFaces();
      sync();
    });
  });

  var q=1;
  document.getElementById('plus').addEventListener('click',function(){ q++; document.getElementById('qty').textContent=q; });
  document.getElementById('minus').addEventListener('click',function(){ if(q>1){q--; document.getElementById('qty').textContent=q;} });
  document.getElementById('cta').addEventListener('click',function(){
    alert('Prototype — this is what would be saved:\n\n'+JSON.stringify(payload(),null,2));
  });

  /* Hidden, not removed: #stageBack, the BACK tab and their handlers all still
     exist, so every painter and null-guard downstream keeps working exactly as it
     did. Removing them would mean auditing a dozen call sites for a null canvas. */
  (function applyProductRules(){
    /* 13/10 owner: «before everything, take off images, keep only text for now, also
       live theme». Photo engraving is PAUSED on every product (gold: the blackening does
       not survive; silver: not approved yet). Paused unless the editor's host says
       data-photo-paused="false" - set by the shop metafield loretana.photo_engraving_on
       (true) in Pre-launch's snippet, so turning photos back on needs no code. A host
       without the attribute (the live theme's older snippet) stays paused. PHOTO_OK
       still decides the Above/Below symbol rows - those are not touched. */
    var _ph = document.querySelector('.lor-eng');
    /* 13/10 05:30 owner: «bring silver back, gold only text». Silver/rhodium photos are
       laser-black now (150 mm/s · 100% · 40 kHz, no blackener) and hold; gold-plated
       photos lose their black, so a GOLD piece offers text only. Gold = 'gold' in the
       handle (the same rule as is_gold() in watch_orders.py; 11 of 29 on 12/10).
       data-photo-paused: 'all' pauses every piece, 'false' pauses none, anything else
       (or missing, as on the live theme's older snippet) pauses gold only. */
    var _pv = _ph ? (_ph.getAttribute('data-photo-paused') || '') : 'false';
    var _isGold = !!_ph && /gold/i.test(_ph.getAttribute('data-product-handle') || '');
    /* 13/10 06:00 owner: «yes stop for now» - the laser-black silver photo came off after
       50 wipes with a silver-polishing cloth, so photos are paused on silver too. The
       gold-only rule above stays written for when a durable silver recipe is approved:
       change this line back to  _pv === 'all' || (_pv !== 'false' && _isGold)  */
    var PHOTO_PAUSED = _pv !== 'false';
    if(!PHOTO_OK || PHOTO_PAUSED){
      var pb = document.querySelector('.seg button[data-mode="photo"]');
      if(pb) pb.style.display = 'none';
      /* belt and braces: if a state ever arrives set to photo - a restored draft, a
         product whose field was turned off after the fact - it must not stay there,
         or the customer sees a mode they cannot reach and cannot leave. */
      ['front','back'].forEach(function(k){
        if(S[k].mode === 'photo'){ S[k].mode = 'none'; S[k].art = null; S[k].thumb = ''; }
      });
    }
    /* The FRONT/BACK tab row goes either way: with one face there is nothing to
       switch, and with two the faces themselves are the switch. */
    var tabs = document.querySelector('.tabs');
    if(tabs) tabs.style.display = 'none';
    var faces = document.getElementById('edFaces');
    if(SIDES === 2){ if(faces) faces.classList.add('two'); return; }
    /* Hide the whole card, not just its canvas - otherwise a one-faced piece kept an
       empty BACK caption bar sitting under nothing. */
    var fb = document.getElementById('faceBack');
    if(fb) fb.style.display = 'none';
    if(edCB) edCB.style.display = 'none';
    S.back.mode = 'none';
    side = 'front';
    [ document.querySelector('.faces [data-openside="back"]'),
      document.querySelector('.sides [data-openside="back"]')
    ].forEach(function(el){ if(el) el.style.display = 'none'; });
    /* Both are two-column grids. Hiding the back does not remove its column, so the
       piece sat in the left half with an empty half beside it. One face gets one
       column - and the piece grows into the space instead of leaving it blank. */
    [ document.querySelector('.faces'), document.querySelector('.sides')
    ].forEach(function(el){ if(el) el.style.gridTemplateColumns = '1fr'; });
    var who = document.querySelector('.sides [data-openside="front"] .who');
    if(who) who.textContent = lorT('ENGRAVING');
  })();

  /* Before buildFonts/buildIcons, so the tray is built with the table already read,
     and before reserveFaces/sync, so nothing is measured against English text that
     is about to be replaced by a longer word. */
  translateDom(document.querySelector('.lor-eng') || document.body);
  /* CSS ::after content cannot be reached by translateDom, so the one word the
     stylesheet owns is handed to it as a custom property instead. */
  (function(){
    var f = lorT(' fits');
    if(f !== ' fits') document.documentElement.style.setProperty('--lor-fits', JSON.stringify(f));
  })();

  buildFonts();
  buildIcons('');
  document.getElementById('title').textContent = productName();
  /* B.10 - the box is reserved BEFORE the first paint, which is the whole point:
     reserving it after sync() would already be one frame too late. */
  reserveFaces();
  sync();

  /* B.10 - rotation and mid-session resize. fitCanvasToPhoto() itself is viewport
     independent, so this is not what refits the canvas; what it buys is the repaint,
     because sync() is where every JS measurement against the canvas box is retaken.
     Debounced, because a rotation fires resize many times and sync() repaints. */
  var fitT = null;
  window.addEventListener('resize', function(){
    clearTimeout(fitT);
    fitT = setTimeout(function(){ fitCanvasToPhoto(); sync(); }, 150);
  });
  /* iOS reports the OLD innerWidth inside orientationchange; 300ms is after the rotate
     animation, and resize above catches anything that settles later. */
  window.addEventListener('orientationchange', function(){
    setTimeout(function(){ fitCanvasToPhoto(); sync(); }, 300);
  });

  /* --- the only opening in the closure: the theme bridge needs to read state --- */
  window.LoretanaEngraving = {
    payload: payload,
    render: renderEngraving,
    /* Same renderer, smaller canvas. The proof panel needs a 96 px thumbnail and must
       not pay for a 900 px encode per face while a dialog is opening. */
    renderAt: function(k, px){ return renderEngraving(k, px); },
    /* The tray tile's own wording, so the receipt names the symbol she picked
       instead of printing its id. */
    iconLabel: iconLabel,
    /* 'before'/'after' are STORED values; these are the words shown to her. */
    posLabel: posLabel,
    state: function(){ return S; },
    shape: function(){ return shape; },
    /* The editor's own SIDES, not a second reading of the metafield: it defaults to 2
       when the attribute is absent, and a bridge that re-derived it defaulted to 1 -
       so an unconfigured product would have shown a two-face editor and a one-face
       receipt. One source, no drift. */
    sides: function(){ return SIDES; },
    /* '' or the face whose text the chosen font cannot cut. The bridge asks before it
       adds to cart, so bypassing the editor cannot bypass the guard. */
    blocked: blockedReason,
    /* A.14 - the bridge sees the theme swap the variant; this is what the editor does
       about it. Named reprice because that is what it will also do once the plating
       metafield exists; today it keeps the variant id on the workshop record honest. */
    reprice: applyVariant
  };

})();

/* ---------------------------------------------------------------------------
   Theme bridge - the only part of the editor that talks to Shopify.

   The contract below was read out of the LIVE snippet (snippets/personilzed-card.liquid)
   on 2026-09-18, not invented here. The four visible property names and the four
   FormData keys are exactly what the current backend and the current orders use:

     properties[Engraving Front Type]   properties[Engraving Front Text]
     properties[Engraving Font Style]   properties[Engraving Shape]
     properties[_engraving]             (hidden, underscore-prefixed)

     POST https://loretana-backend-flame.vercel.app/generate/upload
     FormData: sessionId | original | shape | qr

   Anything new this editor produces - the back side, the symbol, its position, the
   scale - goes INSIDE properties[_engraving] as JSON rather than becoming new visible
   cart lines. Additive, so old orders and the backend keep working unchanged.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Uploading writes a real row and a real file to Supabase. It was left OFF while the
     test theme was only being looked at. Turned ON on 2026-09-19 on the owner's word,
     together with the two payload fixes below - flipping it on its own would have
     returned HTTP 400 on every typed engraving and stopped the customer at the button. */
  var UPLOAD_ENABLED = true;
  var UPLOAD_URL = 'https://loretana-backend-flame.vercel.app/generate/upload';

  var api = window.LoretanaEngraving;
  if (!api) { return; }

  function form() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function setProperty(name, value) {
    var f = form();
    if (!f) { return; }
    var key = 'properties[' + name + ']';
    var input = f.querySelector('input[name="' + key.replace(/"/g, '\\"') + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.setAttribute('data-loretana-engraving', '1');
      f.appendChild(input);
    }
    input.value = value == null ? '' : String(value);
  }

  function removeProperty(name) {
    var f = form();
    if (!f) { return; }
    var input = f.querySelector('input[name="properties[' + name + ']"][data-loretana-engraving]');
    if (input) { input.parentNode.removeChild(input); }
  }

  /* The session id is the ONLY link between a Shopify line and its Supabase row, and it
     used to live for the whole page. Two pieces engraved without reloading therefore
     shared one key: the second upsert overwrote the first, and the workshop received one
     file for two different engravings with nothing to tell them apart. A key now belongs
     to ONE add. It is minted lazily and retired only once that add has landed - never at
     the start of an attempt, because a retry must reuse its key or the two writes would
     not even agree with each other. */
  function sessionId() {
    if (!window.__lorSession) {
      window.__lorSession = 's_' + Date.now().toString(36) + '_' +
                            Math.random().toString(36).slice(2, 10);
    }
    return window.__lorSession;
  }

  function newSession() { window.__lorSession = null; }

  /* What the per-page id became: a way to see that two rows came from one visit, which
     is useful to us and harmless to the workshop. */
  function visitId() {
    if (!window.__lorVisit) {
      window.__lorVisit = 'v_' + Date.now().toString(36) + '_' +
                          Math.random().toString(36).slice(2, 8);
    }
    return window.__lorVisit;
  }

  /* "Text mode with nothing typed" is not an engraving. Without this the cart shows
     a line marked as engraved whose text property is empty - Shopify drops empty
     values - so the order reads as personalised but carries nothing to engrave.
     Seen in the cart on 2026-09-18 while testing.

     payload() spells a photo side "image", never "photo". The earlier copy of this
     test only knew "photo", so an image side fell through to the final `return true`
     and counted as engraved even with the photo slot still empty. Both spellings are
     accepted here, and an image side now has to actually carry a picture. */
  function hasSide(sideData) {
    if (!sideData || !sideData.type || sideData.type === 'none') { return false; }
    if (sideData.type === 'text') { return !!(sideData.engraving_text || sideData.engraving_icon); }
    if (sideData.type === 'photo' || sideData.type === 'image') { return !!sideData.shape_public_url; }
    return true;
  }

  /* Mirror the editor's state onto the form. Called after every confirm and once
     more immediately before the form is submitted, so a customer who never opens
     the editor sends nothing at all rather than empty properties. */
  function publish() {
    var p;
    try { p = api.payload(); } catch (e) { return; }
    if (!p) { return; }

    var front = p.front || {};
    var back = p.back || {};
    var engraved = hasSide(front) || hasSide(back);

    if (!engraved) {
      ['Engraving Front Type', 'Engraving Front Text', 'Engraving Font Style',
       'Engraving Shape', 'Engraving Back Type', 'Engraving Back Text', '_engraving']
        .forEach(removeProperty);
      return;
    }

    /* the four the backend and the existing orders already rely on */
    setProperty('Engraving Front Type', front.type || 'none');
    setProperty('Engraving Front Text', front.engraving_text || '');
    setProperty('Engraving Font Style', front.engraving_font || '');
    setProperty('Engraving Shape', p.engraving_shape || '');

    /* the back side is new, and visible because the customer paid for it */
    if (hasSide(back)) {
      setProperty('Engraving Back Type', back.type);
      setProperty('Engraving Back Text', back.engraving_text || '');
    } else {
      removeProperty('Engraving Back Type');
      removeProperty('Engraving Back Text');
    }

    /* everything else travels as one hidden blob: symbol, position, scale, session */
    setProperty('_engraving', JSON.stringify({
      session: sessionId(),
      shape: p.engraving_shape,
      frame: p.frame_border,
      front: front,
      back: back,
      editor: 'v2'
    }));
  }

  function dataUrlToBlob(dataUrl) {
    var parts = String(dataUrl).split(',');
    var mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/png';
    var bin = atob(parts[1]);
    var buf = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) { buf[i] = bin.charCodeAt(i); }
    return new Blob([buf], { type: mime });
  }

  /* Which face the workshop marks from, and which face the words are on. They are not
     always the same face: a photo can only be engraved on one side of a piece, so a
     customer can put their picture on the back and their name on the front. Picking
     one "primary" side for everything would have thrown one of the two away. */
  function pickSides(p) {
    var photo = null, text = null, art = null;
    ['front', 'back'].forEach(function (k) {
      var side = p[k] || {};
      if (!hasSide(side)) { return; }
      if (!photo && (side.type === 'image' || side.type === 'photo')) { photo = k; }
      if (!text && side.type === 'text') { text = k; }
      if (!art) { art = k; }
    });
    return {
      art:   photo || art || 'front',
      text:  text || photo || art || 'front',
      photo: photo
    };
  }

  /* Everything the backend is willing to store about the piece, filled from the
     editor's own payload.

     Read out of the backend source and measured against Supabase on 2026-09-19: the
     service maps fourteen named fields onto real columns and drops every other string
     field into metadata.extraFormFields (jsonb). The bridge was sending none of them -
     which is why 108 rows carried a picture and a null engraving_text, and why the
     owner still read the engraving out of Shopify by hand. Because the unknown fields
     are kept, the second side travels too and none of this needs a backend change.

     One field, one meaning: the text columns describe the side carrying the text, the
     framing columns describe the side carrying the photo, and both sides are written
     out in full besides, so nothing downstream has to guess which was which. */
  function meta(p, sides) {
    var root = document.querySelector('.lor-eng');
    function attr(n) { return (root && root.getAttribute(n)) || ''; }
    function str(v) { return (v === null || v === undefined) ? '' : String(v); }
    function kind(side) {
      if (!hasSide(side)) { return 'none'; }
      return (side.type === 'image' || side.type === 'photo') ? 'photo' : side.type;
    }

    var t  = p[sides.text] || {};
    var ph = sides.photo ? (p[sides.photo] || {}) : {};
    var f  = p.front || {};
    var b  = p.back || {};

    return {
      /* the fourteen the backend maps onto columns of its own */
      productId:      attr('data-product-id') || attr('data-product-handle'),
      productName:    p.product_name || attr('data-product-title'),
      engravingType:  sides.photo ? 'photo' : 'text',
      engravingText:  str(t.engraving_text),
      engravingFont:  str(t.engraving_font),
      engravingStyle: str(t.engraving_icon),
      engravingShape: str(p.engraving_shape),
      engravingX:     str(ph.engraving_x),
      engravingY:     str(ph.engraving_y),
      engravingZoom:  str(ph.engraving_zoom),

      /* unknown to the backend, so these are kept under metadata.extraFormFields */
      engravingEditor:    'v2',
      engravingVisit:     visitId(),
      engravingArtSide:   str(sides.art),
      engravingTextSide:  str(sides.text),
      engravingIconPos:   str(t.engraving_icon_pos),
      engravingScale:     str(t.engraving_scale),
      engravingFrame:     str(p.frame_border),
      engravingHandle:    attr('data-product-handle'),
      engravingVariantId: attr('data-variant-id'),
      engravingFrontType: kind(f),
      engravingFrontText: str(f.engraving_text),
      engravingFrontFont: str(f.engraving_font),
      engravingFrontIcon: str(f.engraving_icon),
      engravingBackType:  kind(b),
      engravingBackText:  str(b.engraving_text),
      engravingBackFont:  str(b.engraving_font),
      engravingBackIcon:  str(b.engraving_icon)
    };
  }

  /* The engraving-ready render is what the workshop marks from, so it is what gets
     uploaded - not the customer's raw photo. Kept as its own step so that a failure
     to upload can never silently drop the order's engraving data, which is already
     on the form by then. */
  /* ⛔ Do not move this upload to the moment she confirms the engraving, however
     tempting the 1.5 s looks. It writes a row into public.orders - and the owner's phone
     app reads that table DIRECTLY, not Shopify's orders. Uploading on confirm would put
     every abandoned engraving into his workshop list as though it had been bought, and
     at this shop's conversion most confirms are abandoned. The 1.5 s is cheaper than a
     workshop queue nobody can trust. Measured and decided 2026-09-22. */
  function upload() {
    if (!UPLOAD_ENABLED) { return Promise.resolve('upload disabled'); }

    var p;
    try { p = api.payload(); } catch (e) { return Promise.resolve('no payload'); }
    if (!p) { return Promise.resolve('no payload'); }
    if (!hasSide(p.front) && !hasSide(p.back)) { return Promise.resolve('nothing engraved'); }

    var st = api.state ? api.state() : null;
    var sides = pickSides(p);

    var shapeUrl;
    try { shapeUrl = api.render(sides.art); } catch (e) { return Promise.resolve('no render'); }
    if (!shapeUrl) { return Promise.resolve('nothing engraved'); }

    /* One decode, not two. For a typed engraving the `original` slot below carries
       this very same picture, and dataUrlToBlob walks the whole base64 string byte by
       byte - doing it twice bought nothing. */
    var shapeBlob = dataUrlToBlob(shapeUrl);

    var fd = new FormData();
    fd.append('sessionId', sessionId());
    fd.append('shape', shapeBlob, 'shape.png');

    /* The backend refuses any upload that carries no `original` file - it throws
       "original image is required" before it writes a thing. For a photo engraving
       that file is the customer's own picture, exactly as before. For a typed
       engraving there is no picture at all, so the engraving-ready render stands in.
       Without this every typed order came back HTTP 400, and because the buy flow
       turns a failed upload into a blocked checkout, the piece the shop sells most
       would have been the one nobody could buy. */
    var artState = st ? st[sides.art] : null;
    if (artState && artState.art && artState.thumb) {
      /* A downscaled upload is re-encoded as JPEG, so the name has to follow the bytes -
         a JPEG posted as original.png is the kind of thing that works until the day
         something downstream trusts the extension. */
      var ob = dataUrlToBlob(artState.thumb);
      fd.append('original', ob, ob.type === 'image/jpeg' ? 'original.jpg' : 'original.png');
    } else {
      fd.append('original', shapeBlob, 'original.png');
    }

    var fields = meta(p, sides);
    Object.keys(fields).forEach(function (k) {
      var v = fields[k];
      if (v !== '' && v !== null && v !== undefined) { fd.append(k, v); }
    });

    /* A bare fetch on a weak signal can hang for minutes, and Promise.all cannot settle
       until it does - the customer was left on a greyed "Adding…" button with no way
       out and no idea anything was wrong. 20 s, then say so and offer the retry. */
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 20000) : null;
    return fetch(UPLOAD_URL, { method: 'POST', body: fd, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(timer); return r.ok ? 'ok' : 'http ' + r.status; })
      .catch(function (e) {
        clearTimeout(timer);
        return (e && e.name === 'AbortError') ? 'timeout' : 'failed: ' + e.message;
      });
  }

  /* The upload is not slow because of its size - 81 KB - it is slow because the
     function is asleep. Measured on the same payload: 3,684 ms on the first call of the
     session against 1,515 ms once awake, so roughly 2,170 ms of it is nothing but Vercel
     starting a container.

     So it is woken while she is still typing. GET /generate/health exists for exactly
     this, returns {"ok":true} and writes nothing. Once per page, fire and forget: a
     failure here must never surface, because nothing depends on it - the real upload
     reports its own errors. At 6.5 visits a day almost every customer is the one who
     would otherwise have paid the cold start. */
  var warmed = false;
  function warmBackend() {
    if (warmed || !UPLOAD_ENABLED) { return; }
    warmed = true;
    try {
      fetch(UPLOAD_URL.replace(/\/upload$/, '/health'), { method: 'GET', cache: 'no-store' })
        .catch(function () {});
    } catch (e) {}
  }
  var openBtn = document.getElementById('openEd');
  if (openBtn) { openBtn.addEventListener('click', warmBackend, { once: true }); }
  /* Tapping the piece opens the editor too, and that is the commoner path on a phone. */
  ['edCanvas', 'edCanvasBack'].forEach(function (id) {
    var c = document.getElementById(id);
    if (c) { c.addEventListener('pointerdown', warmBackend, { once: true }); }
  });

  var ok = document.getElementById('edOk');
  if (ok) { ok.addEventListener('click', function () { setTimeout(publish, 60); }); }

  /* ------------------------------------------------------------------ buy flow
     The owner asked (2026-09-18) for a confirmation that the piece went into the
     cart, and for the customer to be taken to checkout straight after.

     That turns the plain form POST into an XHR add, because a navigation the moment
     the button is pressed ABORTS any request still in flight - and for an engraved
     piece the request still in flight is the workshop's own file. So the upload is
     awaited BEFORE the redirect, and a failed upload stops the redirect instead of
     sending the customer to pay for an engraving the workshop never received.

     The locale root is honoured (Shopify.routes.root), so a prefixed storefront
     posts to /xx/cart/add.js and lands on /xx/checkout, not the bare paths. */
  /* 1400 ms was not a countdown, it was a flash: the sentence about her engraving
     was gone before it could be read, and there was no way to stop it. 5 s, a bar
     that shows it running, and any touch inside the sheet cancels it for good. */
  /* Five seconds was set when this sheet led to CHECKOUT - a commitment worth a pause.
     It leads to the CART now, which is a stop on the way, and five seconds of watching a
     bar there is the single largest piece of the wait: measured 5,000 ms of a 9,300 ms
     total. 2,500 is long enough to register "yes, that is my engraving" - she designed it
     ten seconds ago, this is reassurance, not something to read - and short enough not to
     be endured. Both buttons stay, so anyone who wants it faster taps. */
  var REDIRECT_MS = 2500;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* The words used to live here, built as an HTML string - and `replace(/[<>&]/g,'')`
     silently ate the ampersand out of "TOM & ANNA", the one sentence whose whole job was
     to reassure her that her text arrived intact. The proof rows below carry the words
     now, as text nodes, so this line is just the piece and no innerHTML remains. */
  function pieceLine() {
    var title = document.querySelector('.lor-eng');
    return (title && title.getAttribute('data-product-title')) || lorT('Your piece');
  }

  function faceName(k) { return k === 'front' ? lorT('FRONT') : lorT('BACK'); }

  function twoSided() {
    /* Ask the editor, never the DOM: SIDES defaults to 2 when the metafield is absent,
       and re-reading the attribute here would default to 1 instead - a two-face editor
       with a one-face receipt on every unconfigured product. */
    try { if (api.sides) { return api.sides() === 2; } } catch (e) {}
    var root = document.querySelector('.lor-eng');
    var n = root && parseInt(root.getAttribute('data-engraving-sides'), 10);
    return n !== 1;
  }

  /* ------------------------------------------------------ what will be engraved
     The last screen before checkout used to show one sentence for 1.4 s. It never
     showed the engraving. She paid without ever seeing the thing she designed.

     Every row here is drawn from the SAME state the upload sends: the photo face
     travels as shape.png + original, and the text face travels as
     engravingBack{Type,Text,Font,Icon} in meta() - measured 2026-09-20. So a BACK
     row is a faithful picture of data the workshop receives, not a promise of a
     file. (Two photo faces cannot occur: index.html disables photo mode on the
     second face while the first holds one.) */
  function fillProof() {
    var host = byId('addedProof');
    if (!host) { return; }
    host.textContent = '';
    var st;
    try { st = api.state(); } catch (e) { return; }
    if (!st) { return; }

    var sides = twoSided() ? ['front', 'back'] : ['front'];
    var any = false;

    sides.forEach(function (k) {
      var side = st[k];
      if (!side) { return; }
      var row = document.createElement('div');
      row.className = 'pf';

      var url = null;
      try { url = api.renderAt ? api.renderAt(k, 256) : null; } catch (e) { url = null; }
      if (url) {
        var im = new Image();
        im.src = url;
        im.alt = lorT(k === 'back' ? lorT('The back of your piece as it will be engraved') : lorT('The front of your piece as it will be engraved'));
        row.appendChild(im);
      }

      var box = document.createElement('div');
      var who = document.createElement('span');
      who.className = 'pf-who';
      who.textContent = faceName(k);
      var what = document.createElement('span');
      what.className = 'pf-what';

      /* textContent, never innerHTML: the ampersand she typed is a character she chose. */
      if (side.mode === 'photo' && side.art) {
        what.textContent = lorT('your photo');
        any = true;
      } else if (side.mode === 'text' && (String(side.text || '').trim() || side.icon)) {
        var bits = [];
        if (String(side.text || '').trim()) {
          bits.push('“' + String(side.text).trim() + '”');
          if (side.font) { bits.push(side.font); }
        }
        if (side.icon) {
          var nm = api.iconLabel ? api.iconLabel(side.icon) : String(side.icon).replace(/-/g, ' ');
          var pl = api.posLabel ? api.posLabel(side.iconPos) : (side.iconPos || 'above');
          bits.push(nm + ' ' + String(pl).toLowerCase());
        }
        what.textContent = bits.join(' · ');
        any = true;
      } else {
        /* Named, not omitted - a face she left empty is a choice, and seeing it said
           back to her is how she catches the one she meant to fill. */
        what.textContent = lorT('left blank');
        what.className = 'pf-what pf-blank';
      }

      box.appendChild(who);
      box.appendChild(what);
      row.appendChild(box);
      host.appendChild(row);
    });

    if (!any) { host.textContent = ''; return; }

    var cap = document.createElement('p');
    cap.className = 'pf-cap';
    cap.textContent = lorT('This is what will be engraved.');
    host.appendChild(cap);
  }

  var dlg   = function () { return document.getElementById('lorAdded'); };
  var addBtn = function () { return document.querySelector('.lor-add[data-lor-add]'); };

  function openAdded() {
    var d = dlg();
    if (!d) { return null; }
    if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); }
    return d;
  }

  function byId(id) { return document.getElementById(id); }

  /* Put the sheet back to its ordinary "added" shape before reusing it for anything
     else - it is one dialog serving three states and a stale hidden flag from the
     previous state is invisible until a customer hits it. */
  function resetAdded() {
    var d = dlg();
    if (!d) { return; }
    var tick = d.querySelector('.added-tick');
    if (tick) { tick.hidden = false; }
    var err = byId('addedErr'); if (err) { err.hidden = true; err.textContent = ''; }
    var retry = byId('addedRetry'); if (retry) { retry.hidden = true; retry.disabled = false;
      retry.textContent = lorT('Try again'); }
    goLine(false);
    var now = byId('addedNow'); if (now) { now.hidden = false; }
    var t = byId('addedTitle'); if (t) { t.textContent = lorT('Added to your cart'); }
    /* The proof panel and its buttons are part of the same one dialog, so they are
       part of the same one reset. A stale hidden flag here is invisible until the
       customer who hits it has no Checkout button. */
    var acts = byId('addedActs'); if (acts) { acts.classList.remove('off'); }
    var bar = byId('addedBar'); if (bar) { bar.classList.remove('off'); }
    var edit = byId('addedEdit'); if (edit) { edit.classList.remove('off'); }
    var pr = byId('addedProof'); if (pr) { pr.textContent = ''; }
  }

  /* One sentence per failure, and every one of them TRUE. The old copy said
     "Nothing was charged - please try again" while the piece was already in the cart,
     because the upload and the cart add were raced with Promise.all. They are now
     ordered, so the message can describe what actually happened. */
  /* The bridge shares the editor's table but not its scope, so it carries its own
     reader. It looks the table up on every call rather than capturing it at load,
     because nothing orders this file against the snippet that defines it. */
  function lorT(en){
    var m = (typeof window !== 'undefined' && window.LORETANA_ENGRAVING_I18N) || null;
    if(!m || en == null) return en;
    var v = m[String(en)];
    return (typeof v === 'string' && v) ? v : en;
  }
  /* The snippet renders 'Add to cart — <price>' in LIQUID, which cannot read this
     table, so the very first paint would stay English until a variant changed.
     Only the prefix is replaced; the price keeps the theme's own formatting. */
  function lorFixAddLabel(){
    var b = document.querySelector('.lor-add');
    if(!b) return;
    var en = 'Add to cart', tr = lorT(en);
    if(tr === en) return;
    /* Liquid renders the label between newlines, so the raw textContent starts with
       whitespace and indexOf(en) was never 0 - measured on loretana.lt: the base
       attribute translated and the visible label did not. Compare on the trim. */
    var cur = (b.textContent || '').trim();
    if(cur.indexOf(en) === 0){
      b.textContent = tr + cur.slice(en.length);
      b.setAttribute('data-lor-label', b.textContent);
    }
    ['data-lor-base', 'data-lor-label'].forEach(function(a){
      var v = b.getAttribute(a);
      if(v && v.indexOf(en) === 0) b.setAttribute(a, tr + v.slice(en.length));
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', lorFixAddLabel);
  } else {
    lorFixAddLabel();
  }

  var COPY = {
    save: { title: lorT('Not added yet'), body: lorT('We could not save your engraving file. Your piece has not been added to the cart.') },
    slow: { title: lorT('Still saving'), body: lorT('Saving your engraving is taking longer than usual. Your piece has not been added to the cart.') },
    cart: { title: lorT('Not added'), body: null }   /* body = Shopify's own sentence */
  };

  function showProblem(kind, detail) {
    var d = dlg();
    var btn = addBtn();
    /* The button stays DISABLED while this sheet is up. Re-enabling it here is what let
       a second press post a second /cart/add with byte-identical properties, which
       Shopify merges into quantity 2 rather than a visibly separate line. It is
       re-enabled by the dialog's own close handler, once, when she dismisses this. */
    if (btn) { btn.textContent = btn.getAttribute('data-lor-label') || lorT('Add to cart'); btn.disabled = true; }
    /* Kill the "saving" timer first. A fast failure - a dead host answers in
       milliseconds - resolves BEFORE the 600 ms wait fires, and without this the timer
       lands afterwards and overwrites the failure with "Saving your engraving", hiding
       the retry button and leaving her on a sheet that waits forever. Measured on the
       test theme 2026-09-19: title stuck at "Saving your engraving", retry hidden. */
    clearTimeout(pendT);
    var c = COPY[kind] || COPY.cart;
    if (!d) { window.alert(c.body || detail); return; }
    holdRedirect();
    d.classList.remove('saving');
    resetAdded();
    var tick = d.querySelector('.added-tick'); if (tick) { tick.hidden = true; }
    var t = byId('addedTitle'); if (t) { t.textContent = c.title; }
    var err = byId('addedErr'); if (err) { err.hidden = false; err.textContent = c.body || detail; }
    goLine(true);
    var now = byId('addedNow'); if (now) { now.hidden = true; }
    /* Nothing on a failure sheet may offer checkout or a countdown - the piece is not
       in the cart. Only the retry remains. */
    var acts = byId('addedActs'); if (acts) { acts.classList.add('off'); }
    var bar = byId('addedBar'); if (bar) { bar.classList.add('off'); }
    var edit = byId('addedEdit'); if (edit) { edit.classList.add('off'); }
    var pr = byId('addedProof'); if (pr) { pr.textContent = ''; }
    var retry = byId('addedRetry'); if (retry) { retry.hidden = false; }
    if (!d.open) { openAdded(); }
  }

  /* The cart, not the checkout. Parcely's Omniva picker is mounted in the theme's
     cart footer, and a Shopify checkout never renders theme snippets - so a jump
     straight to /checkout is a jump past the only place she can pick a parcel
     machine. Measured on the live checkout: zero Parcely elements. Owner, 2026-09-22. */
  /* The countdown line and the reason under it are one thing on screen, so they are one
     thing in the code: hiding the spinner and leaving "choose your pick-up point there"
     behind would promise a step to someone who is no longer being taken anywhere. */
  function goLine(hidden) {
    var a = byId('addedGo');  if (a) { a.hidden = hidden; }
    var b = byId('addedWhy'); if (b) { b.hidden = hidden; }
  }

  function goToCart() {
    window.location.href = root() + 'cart';
  }

  function addToCart(f) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      body: new FormData(f),
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (r.ok) { return body; }
        /* Shopify answers 422 with a human sentence in `description` - show that one,
           not a status code the customer cannot act on. */
        throw new Error(body.description || body.message || lorT('Could not add to cart ({status}).').split('{status}').join(r.status));
      });
    });
  }

  /* The button is type="button" now, so this normally runs from its own click. The
     submit listener stays as a net: anything else that submits the product form (the
     theme, an app, Enter in a field) is caught and routed through the same one add,
     instead of racing it with a second request that carries no engraving. */
  /* ----------------------------------------------------------- the blank nudge
     Buying the piece blank is a real choice and stays one - the editor says the blank
     face costs nothing extra, and Add to cart works without ever opening it (measured
     2026-09-19: cart line with no properties, no Supabase row, straight to checkout).

     But engraving is free and is the reason this piece exists, so a customer who
     simply never noticed the editor is asked once before the order goes out blank.
     Once per page: someone who answered "blank" is not nagged on the second press,
     and neither is someone who opened the editor and chose to leave it empty.
     Owner asked for this on 2026-09-19 after seeing the blank buy go through. */
  var blankAsked = false;

  function nothingEngraved() {
    var p;
    try { p = api.payload(); } catch (err) { return false; }
    if (!p) { return false; }
    return !hasSide(p.front) && !hasSide(p.back);
  }

  function askBlank(proceed) {
    var d = document.getElementById('lorBlank');
    var yes = document.getElementById('blankBuy');
    var no  = document.getElementById('blankAdd');
    if (!d || !yes || !no) { return false; }   /* no dialog in this theme - never block the sale */
    blankAsked = true;

    function shut() { if (d.close) { d.close(); } else { d.removeAttribute('open'); } }
    yes.onclick = function () { shut(); proceed(); };
    no.onclick = function () {
      shut();
      var open = document.getElementById('openEd');
      if (open) { open.click(); }
    };
    if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); }
    return true;
  }

  function buy(f, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); } }
    if (!f) { return; }

    /* A font that cannot cut her letters must not reach the workshop, and the editor is
       not the only way to this button. One path, one wording: reopen the editor and let
       its own CONFIRM say what is wrong. */
    if (api.blocked && api.blocked()) {
      var openBtn = document.getElementById('openEd');
      var okBtn = document.getElementById('edOk');
      if (openBtn && okBtn) { openBtn.click(); okBtn.click(); }
      return;
    }

    /* Ask before the piece goes out blank. Escape closes it and nothing happens - the
       next press then goes straight through, because the question was already put. */
    if (!blankAsked && nothingEngraved() && askBlank(function () { buy(f); })) { return; }
    if (!dlg()) { publish(); if (UPLOAD_ENABLED) { upload(); } f.submit(); return; }

    publish();

    var btn = addBtn();
    if (btn) {
      if (!btn.getAttribute('data-lor-label')) { btn.setAttribute('data-lor-label', btn.textContent.trim()); }
      if (btn.disabled) { return; }
      btn.disabled = true;
      btn.textContent = lorT('Adding…');
    }

    pendingForm = f;
    runAdd();
  }

  /* ------------------------------------------------------- the ordered add
     The engraving file is saved FIRST and the line is added only once it is safe.
     Racing them with Promise.all is what made every failure message a lie: the cart
     already held the piece while the sheet said it did not, and the retry button -
     which only closed the dialog - invited a second press that added it twice.

     Three pieces of state, and they must be reset when the sheet is dismissed after a
     success, or the NEXT add on the same page would print the tick, write a second
     Supabase row and never call /cart/add.js at all. "Keep shopping" walks exactly
     that path. */
  var pendingForm = null, lineAdded = false, uploadDone = false, pendT = null;

  function resetAttempt() { lineAdded = false; uploadDone = false; }

  /* Cancelling has to remove the PROMISE as well as the timer. Leaving "Taking you to
     checkout..." on screen after she stopped it is the same lie in a quieter voice. */
  function holdRedirect() {
    if (redirT) { clearTimeout(redirT); redirT = null; }
    var bar = byId('addedBar'); if (bar) { bar.classList.add('off'); }
    goLine(true);
  }
  function startRedirect() {
    if (redirT) { clearTimeout(redirT); redirT = null; }
    var bar = byId('addedBar');
    if (bar) {
      bar.classList.remove('off');
      bar.style.setProperty('--lor-count', REDIRECT_MS + 'ms');
      /* Restart the animation on a reused node - without this the second add on the
         same page shows a bar that never moves. */
      var fill = bar.firstElementChild;
      if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }
    }
    goLine(false);
    redirT = setTimeout(goToCart, REDIRECT_MS);
  }
  var redirT = null;

  function finishAdd() {
    clearTimeout(pendT);
    var d = dlg();
    if (d) { d.classList.remove('saving'); }
    resetAdded();
    d = openAdded();
    var line = byId('addedLine'); if (line) { line.textContent = pieceLine(); }
    fillProof();                       /* draw it BEFORE the countdown starts */
    var now = byId('addedNow'); if (now) { now.setAttribute('href', root() + 'cart'); }
    newSession();      /* this add has landed - the next one gets its own key */
    resetAttempt();
    if (!d) { goToCart(); return; }
    startRedirect();
  }

  function runAdd() {
    clearTimeout(pendT);
    /* If the save has not finished quickly, stop leaving all the feedback on one greyed
       button and show her the sheet, waiting. */
    pendT = setTimeout(function () {
      var d = dlg();
      if (!d || lineAdded) { return; }
      resetAdded();
      var tick = d.querySelector('.added-tick'); if (tick) { tick.hidden = true; }
      var t = byId('addedTitle'); if (t) { t.textContent = lorT('Saving your engraving'); }
      var line = byId('addedLine'); if (line) { line.textContent = lorT('A moment — your piece has not been added yet.'); }
      goLine(true);
      var now = byId('addedNow'); if (now) { now.hidden = true; }
      var acts0 = byId('addedActs'); if (acts0) { acts0.classList.add('off'); }
      var bar0 = byId('addedBar'); if (bar0) { bar0.classList.add('off'); }
      var edit0 = byId('addedEdit'); if (edit0) { edit0.classList.add('off'); }
      d.classList.add('saving');
      if (!d.open) { openAdded(); }
    }, 600);

    var step = uploadDone ? Promise.resolve('ok') : upload();
    return step.then(function (up) {
      if (UPLOAD_ENABLED && up !== 'ok' && up !== 'nothing engraved' && up !== 'upload disabled') {
        showProblem(up === 'timeout' ? 'slow' : 'save', up);
        return;
      }
      uploadDone = true;                   /* a retry of the CART leg must not re-upload */
      if (lineAdded) { finishAdd(); return; }
      return addToCart(pendingForm).then(function () { lineAdded = true; finishAdd(); });
    }).catch(function (err) {
      showProblem('cart', err && err.message ? err.message : lorT('Could not add to cart.'));
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.lor-add[data-lor-add]') : null;
    if (!b || b.disabled) { return; }
    buy(form(), e);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) { return; }
    buy(f, e);
  }, true);

  /* It was called "Try again" and its only behaviour was to close the dialog. It now
     retries the half that failed - and only that half, because uploadDone survives. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || t.id !== 'addedRetry') { return; }
    t.disabled = true;
    t.textContent = lorT('Saving…');
    Promise.resolve(runAdd()).then(function () {
      t.disabled = false;
      t.textContent = lorT('Try again');
    });
  });

  /* ---- the countdown belongs to her, not to us --------------------------------
     Any touch inside the sheet cancels the redirect for good. Capturing, so it fires
     before the button's own handler and before anything can stop propagation - a
     customer reaching for "Keep shopping" has already said she is not done. */
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest('#lorAdded .added-in')) { holdRedirect(); }
  }, true);

  /* Keep shopping: stop the clock, close, stay where she is. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var stay = t.closest('#addedStay');
    if (stay) {
      holdRedirect();
      var d1 = dlg();
      if (d1) { if (d1.close) { d1.close(); } else { d1.removeAttribute('open'); } }
      return;
    }
    /* Change my engraving: the piece is already in the cart, so this reopens the editor
       for the NEXT one rather than editing the line - said plainly by the label, which
       is "Change my engraving" and not "Edit this item". */
    var edit = t.closest('#addedEdit');
    if (edit) {
      holdRedirect();
      var d2 = dlg();
      if (d2) { if (d2.close) { d2.close(); } else { d2.removeAttribute('open'); } }
      var open = document.getElementById('openEd');
      if (open) { open.click(); }
    }
  });

  /* Dismissing the sheet is the one moment the button may come back: after a failure
     she must be able to try again, and after a success the slate must be clean or the
     next add would skip the cart entirely. */
  (function () {
    var d = dlg();
    if (!d || !d.addEventListener) { return; }
    /* Escape fires `cancel` first. holdRedirect() here means the clock is dead before
       the dialog is even gone, rather than racing the close handler. */
    d.addEventListener('cancel', function () { holdRedirect(); });
    d.addEventListener('close', function () {
      holdRedirect();
      d.classList.remove('saving');
      var btn = addBtn();
      if (btn && !lineAdded) { btn.disabled = false; }
      if (lineAdded) { resetAttempt(); }
    });
  })();

  /* ----------------------------------------------------------- A.14 the variant
     Everything about the piece is Liquid-rendered ONCE, for
     product.selected_or_first_available_variant: `data-variant-id` on .lor-eng, the
     price inside this button, and whether the button exists at all. Switch silver to
     14K gold and the editor goes on publishing the first variant's id to Supabase,
     while the button still offers the first variant's price.

     Both listeners the guidance proposed are dead on THIS theme, read out of
     assets/section-product.build.js and assets/product-sticky-form-*.js rather than
     assumed:

       - it dispatches no `variant:change` DOM event. It emits themeCore.EventBus
         `pdp:section-<id>:change-variant` and `form:<id>:change-variant`.
       - it updates the hidden [name="id"] with `element.value = id`. A property write
         fires no `change` event, so a delegated change listener never sees it.

     What it does do is replace `.js-product-options` wholesale with fetched markup, and
     a MutationObserver sees that on any theme without knowing anything about themeCore.
     That swap also happens BEFORE the hidden input is rewritten, which is why the JSON
     in [data-selected-variant] is read first and the input only as a fallback - reading
     the input first would have returned the variant she just left.

     The two proposed listeners are kept anyway: they cost nothing and a Dawn-family
     theme would need them. The poll stays as the floor under all of it. */
  (function () {
    var host = document.querySelector('.lor-eng');
    if (!host) { return; }
    /* .lor-eng renders inside the product form (product-form.liquid:87), so this is the
       right form even on a page that also carries product cards with forms of their own. */
    var scope = (host.closest && host.closest('form')) || document;

    /* Sold out: she must not spend five minutes engraving something she cannot buy.
       Shown to the owner on 2026-09-21 as two drawn screens rather than described, and
       he picked the locked one. The editor CTA therefore goes dead with the buy button,
       and `.cta-open[disabled]` was added in the same pass - without it `disabled` left
       the button full green and looking alive. */
    var SOLD_OUT_LOCKS_EDITOR = true;

    function selected() {
      var el = scope.querySelector('[data-selected-variant]');
      if (!el) { return null; }
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    function currentId() {
      var v = selected();
      if (v && v.id != null) { return String(v.id); }
      var i = scope.querySelector('[name="id"]');
      if (i && i.value) { return String(i.value); }
      return host.getAttribute('data-variant-id') || '';
    }
    /* The theme's own formatter, so the price reads exactly as every other price on the
       page in every currency the shop sells in. No formatter, no rewrite: a guessed
       "EUR 7999" under the customer's thumb is worse than a stale one. */
    function money(cents) {
      try {
        var u = window.themeCore && window.themeCore.utils;
        var shop = window.themeCore && window.themeCore.objects && window.themeCore.objects.shop;
        if (u && u.formatMoney && shop && shop.money_format) {
          return u.formatMoney(cents, shop.money_format);
        }
      } catch (e) {}
      return null;
    }

    /* The theme relabels and disables its OWN buttons on a variant change - the function
       keyed on '[type="submit"]' in product-sticky-form. Ours is type="button" on
       purpose, because a submit made the theme add the line a second time (measured on
       the test theme 2026-09-18). So the theme's sold-out handling steps straight over
       it, and nothing else was doing it. */
    function paintButton(v) {
      var btn = document.querySelector('.lor-add');
      if (!btn || !v) { return; }
      if (!btn.getAttribute('data-lor-base')) {
        btn.setAttribute('data-lor-base', btn.textContent.trim());
      }
      if (v.available === false) {
        btn.disabled = true;
        btn.removeAttribute('data-lor-add');
        btn.setAttribute('data-lor-soldout', '1');
        btn.textContent = lorT('Sold out \u2014 engraving saved for when it returns');
        btn.setAttribute('data-lor-label', btn.textContent);
      } else {
        var m = v.price != null ? money(v.price) : null;
        var label = m ? (lorT('Add to cart') + ' \u2014 ' + m)
                    : (btn.getAttribute('data-lor-soldout') ? btn.getAttribute('data-lor-base') : null);
        btn.disabled = false;
        btn.setAttribute('data-lor-add', '');
        btn.removeAttribute('data-lor-soldout');
        if (label) { btn.textContent = label; btn.setAttribute('data-lor-label', label); }
      }
      if (SOLD_OUT_LOCKS_EDITOR) {
        var gone = (v.available === false);
        var open = document.getElementById('openEd');
        if (open) { open.disabled = gone; }
        /* A dead control with no explanation reads as a broken page. The sentence is
           what tells her the engraving is not gone, only waiting. */
        var why = document.getElementById('ctaWhy');
        if (why) { why.classList.toggle('hidden', !gone); }
      }
    }

    var last = null;
    function check() {
      var id = currentId();
      var v = selected();
      if (id === last) { return; }
      last = id;
      if (id) { host.setAttribute('data-variant-id', id); }
      /* re-reads the plating, repaints the plate, and re-runs sync() */
      if (api.reprice) { try { api.reprice(id); } catch (e) {} }
      paintButton(v);
      /* the form now carries the engraving against the variant actually selected */
      publish();
    }
    /* First pass sets the baseline and paints the button from the JSON rather than from
       Liquid, which is what makes a page LOADED on ?variant=<sold out> honest too. */
    check();

    if (window.MutationObserver) {
      var watched = scope.querySelector('.js-product-options') || scope;
      new MutationObserver(function () {
        check();
        /* the hidden input is rewritten a tick later; harmless, the id guard absorbs it */
        setTimeout(check, 0);
      }).observe(watched, { childList: true, subtree: true });
    }
    document.addEventListener('variant:change', check);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') { check(); }
    });
    /* themeCore may not be parsed yet when this runs, so the binding is attempted again
       once the page is up. Guarded, because listening twice would double every check. */
    var bound = false;
    function bindBus() {
      if (bound) { return; }
      try {
        var sec = host.closest && host.closest('[data-section-type="product"]');
        var sid = sec && sec.getAttribute('data-section-id');
        var bus = window.themeCore && window.themeCore.EventBus;
        if (bus && bus.listen && sid) {
          bus.listen('pdp:section-' + sid + ':change-variant', check);
          bound = true;
        }
      } catch (e) {}
    }
    bindBus();
    document.addEventListener('DOMContentLoaded', bindBus);
    setTimeout(bindBus, 2000);

    /* The floor. One string comparison; nothing touches the DOM while it matches. */
    setInterval(check, 1200);
  })();

  publish();
  window.LoretanaEngravingBridge = { publish: publish, upload: upload, session: sessionId,
                                     addToCart: addToCart, checkoutUrl: function () { return root() + 'checkout'; } };
})();
